import React, {useState, useEffect} from "react";

export default function ParkaPrimoAussenjackeFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(darkContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M248.783,387.512c-4.492-0.094-8.476-0.309-13.991-0.606l-2.041-0.109
		c-2.808-0.148-5.988-0.315-9.748-0.494c-25.574-1.222-67.669-10.646-70.143-12.916c-1.817-1.778-2.24-3.326-2.824-5.469
		c-0.119-0.437-0.247-0.905-0.39-1.4c-0.62-2.098,0.144-20.25,0.6-31.094c0.177-4.154,0.329-7.742,0.339-9.045
		c0.05-4.607,0.419-21.958,0.608-24.617c0.329-4.807,0.634-9.717,0.925-14.465c1.115-18.132,2.268-36.88,5.424-54.924
		c1.266-7.222,4.455-38.059,4.814-41.551l0.295-2.867l-1.949,1.905c-1.92,1.877-3.958,3.696-6.05,5.55
		c-2.643,2.341-5.638,4.995-8.309,7.85l-0.084,0.09l-0.011-0.001l-0.323,0.353c-1.083,1.187-2.021,2.302-2.866,3.408
		c-2.189,2.877-4.273,5.894-6.289,8.812c-2.988,4.327-6.035,8.738-9.483,12.812c-5.54,6.544-11.464,12.957-17.194,19.16
		c-7.343,7.952-14.894,16.129-21.781,24.717c-6.079,7.591-11.498,16.103-16.737,24.334l-0.551,0.865
		c-0.971,1.527-1.94,3.05-2.913,4.562c-0.606,0.941-1.853,2.896-1.853,2.896l-0.033,0.074
		c-5.729,12.582-13.343,25.438-17.441,25.793c-0.055,0.007-0.151,0.008-0.167,0.008c-6.572,0-39.067-21.945-40.384-23.324
		c-0.239-0.266-0.409-0.75-0.487-1.398c-0.13-1.132,0.117-2.33,0.695-3.37c3.219-5.77,18.67-36.027,19.447-38.755
		c0.912-3.201,2.744-6.359,4.515-9.412c0.785-1.352,1.488-2.564,2.114-3.764c3.751-7.192,7.221-13.401,10.606-18.983
		c2.507-4.136,5.11-8.586,7.627-12.889l0.239-0.409c3.33-5.7,6.773-11.594,10.176-17.086c1.914-3.091,3.906-6.553,6.09-10.585
		c1.144-2.111,2.28-4.271,3.386-6.376c0,0,1.572-2.988,2.191-4.157c3.912-7.391,7.666-13.797,11.478-19.586
		c3.198-4.85,6.796-9.418,10.276-13.836l0.068-0.086c1.218-1.547,2.44-3.101,3.649-4.669c1.385-1.791,2.77-3.587,4.15-5.383
		l9.145-11.895c1.586-2.062,5.402-7.008,5.402-7.008l4.124-5.327c1.539-1.982,3.082-3.96,4.63-5.936
		c1.463-1.868,2.928-3.725,4.396-5.583l0.237-0.298c1.266-1.588,2.532-3.176,3.811-4.754c1.325-1.64,2.5-3.073,3.587-4.379
		c1.164-1.393,2.121-2.519,3.017-3.536c0.669-0.764,1.467-1.662,2.329-2.544l0.083-0.083c0.503-0.511,0.933-0.947,1.422-1.282
		l0.142-0.088l0.194-0.188l0.113-0.132c0.059-0.052,0.102-0.09,0.139-0.128c0.038-0.033,0.086-0.086,0.138-0.146l0.178-0.115
		l0.064-0.187c2.014-2.135,5.373-4.971,8.075-6.229c6.065-2.834,32.696-14.14,52.2-17.701l0.627-0.115l0.173-0.681
		c1.014-3.995,2.047-8.387,2.958-12.262c2.219-9.428,4.734-20.114,6.097-20.889c2.187-1.24,18.194-6.338,33.362-6.553l0.138,0.003
		c15.097,0.268,30.982,5.332,33.136,6.55c1.359,0.773,3.878,11.466,6.1,20.9c0.911,3.867,1.942,8.251,2.956,12.25l0.173,0.681
		l0.628,0.115c19.496,3.56,46.13,14.867,52.195,17.701c2.734,1.273,6.138,4.159,8.145,6.301c0,0,0.094,0.103,0.105,0.116v0.188
		l0.368,0.221c0.024,0.027,0.187,0.238,0.187,0.238l0.164,0.098c0.5,0.3,0.947,0.761,1.38,1.208l0.206,0.208
		c1.776,1.813,3.459,3.826,5.085,5.773c2.703,3.236,5.232,6.402,7.395,9.12c2.46,3.094,5.142,6.509,8.695,11.073
		c2.702,3.479,5.556,7.163,9.24,11.952l8.975,11.671c10.106,13.147,18.591,27.869,26.795,42.106
		c2.357,4.099,5.098,8.853,7.806,13.425c7.472,12.601,15.153,25.235,22.83,37.551c1.394,2.235,2.831,4.488,4.235,6.688l0.635,0.994
		c2.238,3.493,4.609,7.207,6.831,10.862l0.597,0.982c3.068,5.041,6.539,10.739,8.118,16.286c0.457,1.605,1.325,3.14,2.166,4.625
		l0.082,0.147c0.276,0.488,0.548,0.966,0.791,1.436c2.141,4.066,4.269,7.98,6.25,11.605c2.034,3.728,4.26,7.774,6.805,12.37
		l3.38,6.093c1.131,2.03,1.139,4.841,0.021,7.338c-0.081,0.184-0.161,0.342-0.248,0.484c-0.359,0.593-0.881,0.897-1.434,1.219
		l-0.248,0.143c-0.713,0.431-5.14,3.128-5.14,3.128c-2.856,1.738-5.787,3.523-8.691,5.25c-3.958,2.35-8.228,4.842-12.633,7.145
		l-0.794,0.422c-2.858,1.503-5.731,3.013-8.699,3.709c-0.398,0.096-0.82,0.184-1.235,0.184c-0.083,0-0.167-0.003-0.251-0.012
		c-4.124-0.356-12.466-12.838-18.474-24.286c-5.648-8.884-11.721-18.285-18.175-27.396c-5.581-7.879-12.144-15.133-18.489-22.148
		c-2.199-2.425-4.546-5.022-6.806-7.598l-18.12-20.654c-3.733-4.249-7.106-8.766-10.368-13.135l-0.217-0.291
		c-1.666-2.232-3.389-4.54-5.162-6.811c-3.606-4.625-7.79-8.545-11.835-12.335c-1.795-1.679-3.549-3.329-5.273-5.047l-1.964-1.956
		l0.304,2.912c1.208,11.597,2.636,23.323,4.017,34.663l0.091,0.748c2.008,16.477,4.084,33.516,5.519,50.355
		c0.407,4.769,0.662,9.63,0.909,14.332l0.026,0.494c0.176,3.39,0.357,6.896,0.598,10.327c0.185,2.694,0.556,20.186,0.603,24.621
		c0.015,1.216,0.135,4.236,0.339,9.041c0.46,10.838,1.23,28.978,0.607,31.087c-0.148,0.495-0.277,0.968-0.396,1.408
		c-0.588,2.147-1.012,3.696-2.821,5.47c-2.472,2.267-44.567,11.692-70.141,12.913l-7.113,0.341
		c-8.025,0.394-14.957,0.734-20.391,0.868H248.783z"
        />
        <path
          fill="#223A73"
          d="M245.441,209.356l-18.331-0.543c3.573-0.073,10.947,0.229,17.52,0.506
		C244.901,209.33,245.168,209.34,245.441,209.356"
        />
        <path
          fill="#223A73"
          d="M283.074,194.444c-1.093,6.65-2.079,11.832-2.816,14.411L283.074,194.444z"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M65.012,307.345c-3.774,7.95-11.904,23.264-16.261,23.646c-0.065,0.005-0.132,0.005-0.201,0.005
		c-6.31,0-38.675-21.682-40.084-23.211c-0.192-0.22-0.333-0.627-0.398-1.185c-0.122-1.055,0.107-2.166,0.648-3.132
		c1.802-3.237,7.435-14.14,12.19-23.604C37.884,290.006,62.454,304.98,65.012,307.345"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M493.404,307.966c-0.075,0.171-0.149,0.318-0.231,0.449c-0.3,0.501-0.769,0.772-1.309,1.09l-0.268,0.157
		c-0.684,0.412-1.365,0.831-2.05,1.243l-2.211,1.346c-3.122,1.905-6.357,3.878-9.553,5.778c-3.727,2.214-8.144,4.797-12.618,7.141
		l-0.789,0.417c-2.788,1.467-5.675,2.987-8.633,3.687c-0.431,0.098-0.929,0.202-1.393,0.166c-4.36-0.38-13.054-14.673-17.166-22.168
		c3.197-2.557,28.325-16.426,45.51-25.707c0.174,0.318,0.348,0.642,0.517,0.95c2.038,3.732,4.266,7.778,6.811,12.375
		c1.122,2.032,2.249,4.063,3.379,6.093C494.469,302.903,494.469,305.58,493.404,307.966"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M399.441,140.337c-1.337,4.014-10.515,16.802-14.964,22.778c-0.159,0.376-0.399,0.715-0.625,1.023
		c-0.145,0.199-0.309,0.371-0.478,0.538c-0.095,0.099-0.193,0.188-0.296,0.267c-1.953,2.447-8.59,10.397-14.088,12.829l-0.005-0.005
		c-0.163,0.146-0.352,0.255-0.553,0.329c-0.01,0.005-0.014,0.005-0.023,0.009c-0.282,0.184-0.583,0.287-0.896,0.319
		c-6.98,3.142-22.166,10.914-24.936,12.34c-0.671-0.658-1.342-1.316-2.004-1.989c0.352-3.325,2.934-27.774,3.896-36.741
		c0.325-3.017,1.306-7.469,2.469-12.407c0.023,0.125,0.056,0.245,0.084,0.366c0.062-1.175,0.315-2.297,0.742-3.602
		c-0.004-0.052-0.014-0.099-0.018-0.151c0.084-0.339,0.164-0.68,0.249-1.018c2.056-8.56,4.338-18.092,5.158-25.754
		c0.029,0.073,0.066,0.156,0.099,0.229c-0.033-0.835-0.005-1.707,0.038-2.678c0.014-0.245,0.056-0.46,0.112-0.667
		c0.014-0.204,0.029-0.413,0.038-0.616c0.403-10.419,1.492-17.888,1.953-20.691c0.398,0.277,0.779,0.667,1.151,1.049l0.196,0.204
		c1.784,1.816,3.469,3.836,5.098,5.788l0.038,0.042c2.643,3.168,5.187,6.348,7.328,9.036c2.539,3.2,5.304,6.718,8.689,11.076
		c2.708,3.476,5.557,7.16,9.242,11.947c2.155,2.798,4.305,5.601,6.46,8.398l2.515,3.274
		C397.24,137.336,398.348,138.828,399.441,140.337"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M161.514,188.776c-0.657,0.667-1.338,1.326-2.023,1.979c-2.844-1.462-18.189-9.317-25.071-12.398
		c-0.648-0.151-1.212-0.506-1.826-0.818c-0.004-0.006-0.009-0.011-0.014-0.011c-5.628-2.803-12.238-10.893-13.796-12.867
		l0.009-0.015c-0.31-0.241-0.507-0.6-0.723-0.94c-0.033-0.047-0.07-0.094-0.112-0.136c-0.023-0.02-0.038-0.047-0.057-0.073
		c-4.374-5.846-14.049-19.281-15.289-23.259c0.695-0.904,1.39-1.806,2.085-2.708l4.469-5.815c1.559-2.025,3.117-4.05,4.674-6.076
		c1.587-2.066,3.179-4.128,4.77-6.19c1.581-2.051,3.168-4.098,4.754-6.143c1.546-1.984,3.085-3.963,4.634-5.94
		c1.46-1.864,2.925-3.722,4.394-5.575c1.343-1.691,2.69-3.377,4.047-5.054c1.323-1.638,2.493-3.069,3.581-4.374
		c1.165-1.398,2.122-2.521,3.015-3.534c0.718-0.82,1.492-1.691,2.314-2.526l0.089-0.09c0.403-0.418,0.822-0.84,1.258-1.159
		c0.464,2.808,1.549,10.273,1.958,20.681c0.004,0.215,0.023,0.438,0.033,0.653c-0.014,0.036-0.029,0.078-0.042,0.115
		c0.009,0.047,0.013,0.099,0.013,0.157c0.005,0.448,0.014,0.904,0.043,1.352c0.033,0.438,0.061,0.683,0.141,1.122
		c0.028,0.136,0.047,0.272,0.065,0.408c0.014-0.026,0.023-0.052,0.033-0.073c0.817,7.662,3.103,17.194,5.159,25.754
		c0.08,0.339,0.164,0.679,0.244,1.018c0,0.02-0.005,0.036-0.009,0.057c0.099,0.141,0.155,0.313,0.168,0.49c0,0,0.01,0.09,0.01,0.126
		c0.004,0.031,0.009,0.078,0.013,0.083c0.014,0.1,0.038,0.204,0.061,0.303c0.047,0.213,0.108,0.422,0.174,0.637
		c0.117,0.392,0.245,0.783,0.32,1.195c0.029,0.151,0.047,0.313,0.065,0.48c1.169,4.948,2.15,9.401,2.475,12.423
		C158.603,161.226,161.167,185.482,161.514,188.776"
        />
        <path
          fill="#223A73"
          d="M255.618,209.66c-1.136,0.062-5.407-0.11-10.088-0.297L255.618,209.66z"
        />
        <path
          fill="#C8C8C8"
          d="M88.694,271.804c-0.211,0.26-0.427,0.522-0.638,0.782c-3.45,4.307-6.68,8.911-9.793,13.587
		c-4.163-1.081-12.903-5.685-21.822-10.773c3.637-5.804,7.234-11.817,9.346-16.06C74.283,264.523,82.953,269.456,88.694,271.804"
        />
        <path
          fill="#C8C8C8"
          d="M64.622,258.624c-2.089,4.192-5.718,10.247-9.384,16.093c-11.449-6.577-22.87-13.728-24.987-15.064
		c0.756-1.467,1.597-2.927,2.427-4.359c0.762-1.31,1.479-2.547,2.122-3.773c1.657-3.184,3.263-6.164,4.835-9.004
		C42.086,244.166,53.056,251.526,64.622,258.624"
        />
        <path
          fill="#C8C8C8"
          d="M225.711,210.296c-0.249,5.799-0.46,11.609-0.605,17.539c-0.033,1.439-0.076,2.892-0.117,4.348
		c-0.226-0.005-0.361-0.01-0.381-0.01c-17.504,0.339-59.817-7.746-65.478-8.843c0.69-5.679,1.469-12.726,2.141-18.942
		C167.147,204.982,211.479,209.456,225.711,210.296"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M220.275,120.789l-3.548,17.914l-6.211,5.422l-46.016,0.518l-5.286-4.407
		c-0.493-1.712-3.76-13.335-7.183-32.439c10.004,1.545,43.741,6.848,51.565,9.291C208.014,118.467,214.586,119.787,220.275,120.789"
        />
        <path
          fill="#C8C8C8"
          d="M343.135,223.293c-1.352,0.266-2.704,0.521-4.057,0.778c-4.083,0.767-8.289,1.524-12.5,2.254
		c-6.013,1.039-11.519,1.932-16.828,2.725c-6.754,1.002-12.308,1.722-17.467,2.26l-0.958,0.099
		c-1.183,0.125-2.408,0.261-3.595,0.329c-5.577,0.313-11.253,0.402-16.74,0.492c-2.074,0.031-4.15,0.061-6.225,0.108
		c-0.821,0.017-1.648,0.022-2.478,0.027c-1.967,0.015-3.989,0.042-5.986,0.213c0.288-10.36,0.517-18.404,0.606-21.535
		c4.323-0.23,19.889-0.492,20.081-0.492c13.717-0.762,58.279-5.559,63.888-6.169C341.609,210.734,342.375,217.06,343.135,223.293"
        />
        <path
          fill="#C8C8C8"
          d="M255.571,211.142c-0.09,3.262-0.319,11.285-0.601,21.563c-3.346,0.225-22.733-0.313-28.648-0.48
		c0.042-1.456,0.08-2.908,0.116-4.348c0.142-5.946,0.353-11.767,0.606-17.581c3.483-0.083,10.914,0.225,17.532,0.502
		c5.061,0.208,8.619,0.354,10.351,0.354C255.186,211.152,255.397,211.146,255.571,211.142"
        />
        <path
          fill="#C8C8C8"
          d="M222.674,320.065c-0.085,3.011-0.174,6.039-0.267,9.083c-0.132,4.076-0.273,8.178-0.423,12.275
		c-46.462-6.012-68.215-20.482-70.943-22.417c0.137-6.713,0.343-15.189,0.47-17.001c0.08-1.112,0.155-2.228,0.226-3.345
		C156.229,302,175.954,314.695,222.674,320.065"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M352.143,366.609c-0.15,0.506-0.277,0.975-0.4,1.42c-0.591,2.166-0.981,3.59-2.727,5.298
		c-2.177,2.077-44.472,11.603-69.932,12.819c-2.39,0.115-4.714,0.23-6.953,0.339c-7.758,0.381-14.495,0.711-19.846,0.857
		l-1.329,0.015h-2.168c-4.61-0.1-8.726-0.318-14.425-0.625c-3.192-0.174-6.858-0.367-11.355-0.586
		c-0.404-0.016-0.813-0.036-1.226-0.062L220.454,386c-25.634-1.686-65.276-10.664-67.384-12.674
		c-1.742-1.707-2.132-3.132-2.723-5.298c-0.121-0.445-0.253-0.914-0.399-1.42c-0.6-2.031,0.193-20.842,0.62-30.954
		c0.184-4.337,0.329-7.765,0.343-9.055c0.009-1.191,0.047-3.336,0.098-5.878c4.802,3.21,26.875,16.489,70.92,22.178l1.328,0.173
		c0.977,0.12,1.958,0.241,2.957,0.355c0.869,0.041,18.866,0.892,25.297,0.892c0.464,0,0.868-0.006,1.202-0.015l1.337-0.09
		c1.057-0.062,3.019-0.12,5.553-0.193c7.915-0.235,22.639-0.663,36.177-2.167c17.453-1.941,48.628-15.32,55.334-19.312
		c0.033,1.686,0.052,3.11,0.066,4.056c0.009,1.289,0.155,4.718,0.338,9.055C351.946,345.767,352.74,364.578,352.143,366.609"
        />
        <path
          fill="#C8C8C8"
          d="M252.801,321.328v20.774l-0.029,0.725c-4.558,0.162-26.268-0.866-26.465-0.876
		c-1.01-0.116-2.009-0.235-3-0.36c0.15-4.134,0.296-8.278,0.428-12.391c0.094-3.033,0.183-6.046,0.267-9.041
		c4.417,0.255,21.044,1.185,27.592,1.185C252.05,321.344,252.449,321.339,252.801,321.328"
        />
        <path
          fill="#C8C8C8"
          d="M351.082,320.869c-4.525,3.184-37.361,17.507-55.432,19.515c-13.491,1.499-28.183,1.927-36.079,2.157
		c-2.515,0.073-4.366,0.131-5.459,0.193l0.023-0.6V321.39c0.789,0.078,1.813,0.116,2.995,0.116c7.501,0,21.334-1.342,22.048-1.415
		c46.928-5.354,66.709-18.106,71.187-21.441c0.065,1.122,0.137,2.243,0.211,3.355C350.707,303.868,350.946,313.865,351.082,320.869"
        />
        <path
          fill="#C8C8C8"
          d="M471.895,259.356c-2.314,1.539-13.397,8.868-24.555,15.632c-3.074-5.177-6.215-10.694-9.458-16.614
		c11.107-6.838,21.573-13.843,24.362-15.716c0.999,1.591,2,3.194,2.972,4.791l0.6,0.986
		C467.896,251.855,470.168,255.582,471.895,259.356"
        />
        <path
          fill="#C8C8C8"
          d="M446.167,275.699c-8.966,5.392-17.777,10.272-21.927,11.342c-2.061-3.064-4.159-6.123-6.3-9.145
		c-1.465-2.068-2.999-4.088-4.577-6.076c5.831-2.38,14.707-7.449,23.349-12.731C439.956,265.002,443.092,270.52,446.167,275.699"
        />
        <path
          fill="#9A9A9A"
          d="M286.562,125.028c0,0.721-0.527,1.304-1.174,1.304c-0.038,0-0.076-0.009-0.108-0.009v-0.017h-0.005
		c-0.037,0-0.064-0.015-0.097-0.02h-0.015c-0.121,0-0.215-0.047-0.295-0.109c-0.094-0.037-0.164-0.104-0.216-0.188l-0.005,0.042
		c-0.262-0.241-0.432-0.601-0.432-1.002c0-0.188,0.043-0.365,0.109-0.522c0.028-0.125,0.102-0.225,0.196-0.297
		c0.01-0.016,0.014-0.036,0.023-0.052c0.039-0.062,0.089-0.115,0.151-0.151c0.042-0.026,0.084-0.047,0.127-0.068
		c0.047-0.016,0.089-0.042,0.136-0.058c0.047-0.015,0.098-0.031,0.155-0.041c0.094-0.022,0.196-0.037,0.295-0.048
		c0.047-0.005,0.099-0.005,0.146-0.005c0.005,0,0.01,0.005,0.018,0.005c0.019-0.005,0.038-0.01,0.061-0.01
		c0.117,0,0.211,0.042,0.286,0.099c0.16,0.037,0.274,0.142,0.339,0.283C286.444,124.391,286.562,124.694,286.562,125.028"
        />
        <path
          fill="#9A9A9A"
          d="M288.054,119.626c-1.291,9.317-10.914,78.727-11.604,83.566c-0.347,0.104-1.286,0.215-3.178,0.131
		c-0.038-0.006-0.066-0.02-0.089-0.052c-0.019-0.02-0.038-0.057-0.029-0.115l10.491-82.684c0.249-0.042,0.498-0.089,0.751-0.136
		L284.032,124c-0.184,0.292-0.288,0.647-0.288,1.027c0,0.674,0.334,1.259,0.827,1.577l-9.839,75.623l0.657,0.104l9.82-75.498
		c0.06,0.01,0.116,0.022,0.178,0.022c0.905,0,1.643-0.82,1.643-1.828c0-0.386-0.107-0.741-0.291-1.033l0.057-0.01l0.418-4.186
		C287.496,119.74,287.772,119.683,288.054,119.626"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M292.274,118.723c-1.202,9.494-10.289,80.742-13.448,90.232c-0.676,0.048-1.305,0.084-1.878,0.115
		c-0.698,0.016-15.462,0.261-19.997,0.492c0.014-0.386,0.061-1.744,0.132-3.78c0.372-10.669,1.353-39.016,1.737-42.023
		c0.469-3.643,2.276-37.759,2.351-39.179l0.09-1.002c2.305-0.213,9.725-1.065,10.088-1.106c0.094-0.011,4.97-0.695,10.923-1.749
		l-10.435,82.23c-0.056,0.454,0.061,0.914,0.324,1.269c0.263,0.35,0.648,0.558,1.062,0.579c0.511,0.022,0.971,0.032,1.375,0.032
		c2.436,0,3.008-0.408,3.126-1.112c0.127-0.762,10.656-76.702,11.717-84.376C290.397,119.14,291.349,118.936,292.274,118.723"
        />
        <path
          fill="#C8C8C8"
          d="M332.911,77.707c-5.891-1.973-11.745-3.497-17.316-4.515l-1.14-7.714
		c6.637,2.156,13.091,4.552,18.514,6.692C333.066,74.33,333.057,76.704,332.911,77.707"
        />
        <path
          fill={darkenColor}
          d="M283.604,25.849c-1.596,3.378-9.961,18.724-31.216,22.053c-0.459,0.058-0.905,0.115-1.342,0.173
		c-0.436-0.058-0.883-0.115-1.328-0.167c-21.269-3.335-29.635-18.686-31.235-22.059c3.657-1.565,18.758-6.033,32.638-6.226
		C264.958,19.847,279.971,24.3,283.604,25.849"
        />
        <path
          fill="#C8C8C8"
          d="M187.637,65.477l-1.145,7.714c-5.568,1.018-11.425,2.543-17.312,4.515c-0.15-1.002-0.154-3.377-0.06-5.538
		C174.545,70.029,180.999,67.632,187.637,65.477"
        />
        <path
          d="M219.013,270.761c-0.484-0.126-48.782-12.893-57.287-16.964l-0.849-0.406l-0.076,1.023
		c-0.08,1.023-1.882,25.111-1.882,27.204c0,2.224,2.69,7.417,2.995,8.003l0.136,0.254l0.263,0.085
		c0.708,0.219,8.444,2.582,17.664,5.266l0.061,5.936c0.005,0.824,0.54,1.539,1.263,1.702l4.816,1.075
		c0.127,0.026,0.249,0.041,0.376,0.041c0.436,0,0.859-0.166,1.202-0.48c0.441-0.401,0.695-0.997,0.695-1.633v-4.228
		c9.534,2.685,18.917,5.148,22.762,5.596l0.267,0.031l6.417-5.605l1.732-26.751L219.013,270.761z M187.059,301.864
		c0,0.261-0.132,0.418-0.211,0.491c-0.075,0.067-0.239,0.183-0.469,0.131l-4.816-1.075c-0.113-0.027-0.197-0.137-0.197-0.268
		l-0.057-5.533c1.882,0.549,3.812,1.102,5.75,1.649V301.864z M216.548,296.896l-5.525,4.833
		c-8.863-1.175-44.655-12.069-48.097-13.117c-1.089-2.119-2.676-5.673-2.676-6.995c0-1.8,1.451-21.396,1.798-26.083
		c9.971,4.25,50.612,15.07,56.109,16.52L216.548,296.896z"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M218.158,272.055l-1.61,24.841l-5.525,4.833c-8.863-1.176-44.655-12.069-48.097-13.117
		c-1.089-2.119-2.676-5.673-2.676-6.995c0-1.8,1.451-21.396,1.798-26.083C172.019,259.783,212.661,270.604,218.158,272.055"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M187.06,297.26v4.604c0,0.261-0.132,0.418-0.211,0.49c-0.076,0.068-0.239,0.183-0.47,0.132l-4.816-1.076
		c-0.112-0.026-0.197-0.136-0.197-0.267l-0.056-5.533C183.192,296.159,185.121,296.713,187.06,297.26"
        />
        <path
          d="M340.671,256.729l-0.051-1.027l-0.86,0.386c-8.59,3.847-57.142,15.35-57.634,15.466l-0.549,0.131l1.164,26.782l6.294,5.778
		l0.267-0.026c3.855-0.35,13.29-2.563,22.875-5l-0.09,4.228c-0.013,0.636,0.231,1.236,0.663,1.649
		c0.348,0.334,0.784,0.511,1.235,0.511c0.112,0,0.221-0.01,0.333-0.031l4.835-0.95c0.728-0.141,1.277-0.841,1.301-1.665l0.188-5.936
		c9.27-2.437,17.053-4.603,17.773-4.802l0.261-0.074l0.142-0.254c0.32-0.58,3.113-5.701,3.159-7.919
		C342.023,281.879,340.727,257.753,340.671,256.729 M319.125,302.908c-0.005,0.131-0.09,0.241-0.206,0.26l-4.832,0.95
		c-0.229,0.042-0.393-0.073-0.469-0.145c-0.081-0.073-0.207-0.23-0.202-0.49l0.099-4.604c1.948-0.501,3.886-1.002,5.783-1.498
		L319.125,302.908z M340.647,283.94c-0.028,1.314-1.689,4.833-2.826,6.921c-3.46,0.96-39.474,10.914-48.359,11.854l-5.422-4.97
		l-1.085-24.877c5.525-1.309,46.384-11.065,56.443-15.048C339.648,262.513,340.685,282.139,340.647,283.94"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M319.298,297.38l-0.174,5.528c-0.005,0.131-0.09,0.241-0.206,0.261l-4.831,0.95
		c-0.23,0.042-0.394-0.074-0.469-0.145c-0.082-0.074-0.208-0.232-0.203-0.492l0.099-4.604
		C315.463,298.378,317.403,297.876,319.298,297.38"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M340.647,283.94c-0.028,1.314-1.689,4.833-2.827,6.921c-3.459,0.96-39.473,10.914-48.358,11.854
		l-5.422-4.97l-1.085-24.877c5.525-1.309,46.384-11.065,56.443-15.048C339.648,262.513,340.685,282.139,340.647,283.94"
        />
        <path
          fill="#C8C8C8"
          d="M411.745,158.987c-1.906,2.777-11.712,16.937-16.495,20.858c0,0,0,0.005-0.005,0.005
		c-0.249,0.277-0.531,0.506-0.813,0.737c-0.084,0.067-0.174,0.119-0.262,0.171l0.047,0.074c-2.906,3.424-10.942,9.683-13.304,11.039
		c-0.004-0.005-0.004-0.005-0.009-0.01c-0.159,0.104-0.324,0.193-0.502,0.257c-0.455,0.167-0.887,0.412-1.357,0.543
		c-0.038,0.01-0.08,0.01-0.121,0.02c-0.433,0.271-0.977,0.637-1.7,1.123c-4.215,2.829-12.927,8.67-21.865,9.436
		c-2.728-2.985-5.629-5.715-8.468-8.371c-1.062-0.998-2.142-2.005-3.217-3.038c3.897-1.994,18.392-9.396,24.757-12.22
		c0.023-0.016,0.047-0.042,0.07-0.058c0.128-0.084,0.258-0.151,0.389-0.209c0.4-0.213,0.813-0.396,1.231-0.521
		c0.023-0.006,0.042-0.006,0.06-0.011c5.709-2.901,12.06-10.565,13.942-12.944l0.024,0.036c0.042-0.074,0.08-0.142,0.127-0.209
		c0.229-0.355,0.427-0.622,0.69-0.866c0.022-0.027,0.042-0.053,0.06-0.079l-0.018-0.031c2.089-2.788,12.829-17.267,15.364-23.081
		C404.374,147.248,408.135,153.078,411.745,158.987"
        />
        <path
          fill="#C8C8C8"
          d="M158.364,191.808c-1.3,1.201-2.624,2.375-3.924,3.528c-2.812,2.49-5.68,5.042-8.309,7.846
		c-8.726-0.966-17.148-6.613-21.264-9.379c-0.742-0.502-1.301-0.872-1.737-1.143c-0.098-0.048-0.197-0.094-0.296-0.146
		c-0.103-0.052-0.201-0.11-0.305-0.167c-0.009-0.006-0.051-0.032-0.093-0.052c-0.052-0.022-0.216-0.089-0.216-0.089
		c-0.009-0.006-0.009-0.006-0.013-0.006c-0.024-0.006-0.043-0.006-0.057-0.011c-0.15-0.015-0.291-0.051-0.423-0.109l-0.018,0.02
		c-0.018,0.006-0.038,0.006-0.051,0.011c-1.409-0.486-10.628-7.559-13.782-11.28l0.009-0.011c-0.437-0.224-0.766-0.579-0.99-1.002
		l-0.034,0.048c-4.896-3.988-15.885-19.297-17.804-21.995c2.53-3.55,5.22-6.958,7.839-10.283c1.22-1.551,2.441-3.106,3.653-4.672
		c0.371-0.474,0.736-0.955,1.103-1.43c2.413,5.711,13.322,20.414,15.43,23.234l-0.029,0.041c0.267,0.209,0.512,0.47,0.709,0.799
		c0.065,0.11,0.132,0.219,0.197,0.329l0.009-0.016c1.877,2.37,8.211,10.012,13.914,12.929c0.098,0.026,0.197,0.052,0.3,0.094
		c0.065,0.026,0.131,0.062,0.197,0.089c0.014,0.006,0.028,0.006,0.042,0.01c0.179,0.052,0.343,0.141,0.503,0.241
		c0.008,0.005,0.018,0.01,0.028,0.016c0.075,0.036,0.15,0.073,0.215,0.119c0.018,0.016,0.038,0.032,0.057,0.047
		c3.05,1.332,8.322,3.91,13.34,6.416C151.576,188.337,156.337,190.769,158.364,191.808"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M145.663,201.635c-7.287-0.993-13.726-5.132-20.081-8.928c-3.113-1.858-6.493-3.3-9.334-5.647c-2.986-2.465-5.544-5.492-8.293-8.26
		c-4.078-4.109-7.477-8.71-11.257-13.069c-0.584-0.673-6.34-7.304-5.941-7.86"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M101.402,144.08c1.989,3.72,4.376,7.19,6.745,10.617c1.232,1.781,2.484,3.545,3.747,5.299c2.136,2.961,4.216,6.026,6.579,8.785
		c3.703,4.324,7.92,8.843,12.851,11.365l0.117,0.06l0.127,0.034c0.057,0.016,0.106,0.025,0.156,0.047
		c0.089,0.041,0.147,0.068,0.205,0.092l0.111,0.043l0.063,0.012c0.031,0.014,0.084,0.04,0.169,0.093l0.174,0.094l0.062,0.052
		l0.227,0.121c2.571,1.121,7.04,3.27,13.282,6.387c3.583,1.791,7.105,3.579,9.854,4.982"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M356.309,201.635
		c0.313-0.043,0.624-0.092,0.934-0.145"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="359.098"
          y1="201.099"
          x2="359.108"
          y2="201.097"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.86,1.85,0.01,0"
          d="
		M359.108,201.097c6.16-1.524,11.754-5.085,17.283-8.389c3.112-1.859,6.491-3.301,9.332-5.647c2.986-2.465,5.544-5.492,8.292-8.261
		c4.079-4.108,7.478-8.709,11.258-13.068c0.476-0.549,3.526-4.677,4.856-6.489"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M410.13,159.243
		c0.303-0.413,0.518-0.707,0.591-0.809"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="M400.57,144.08
		c-1.989,3.72-4.376,7.19-6.745,10.617c-1.231,1.781-2.484,3.545-3.747,5.299c-2.136,2.961-4.216,6.026-6.579,8.785
		c-3.704,4.324-7.92,8.843-12.851,11.365l-0.118,0.06l-0.126,0.034c-0.057,0.016-0.106,0.025-0.156,0.047
		c-0.089,0.041-0.148,0.068-0.205,0.092l-0.112,0.043l-0.062,0.012c-0.031,0.014-0.084,0.04-0.169,0.093l-0.174,0.094l-0.062,0.052
		l-0.227,0.121c-2.572,1.121-7.04,3.27-13.281,6.387c-3.584,1.791-7.106,3.579-9.855,4.982"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M352.511,85.677
		c-0.049,0.318-0.1,0.662-0.153,1.031"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.659,1.65"
          d="M352.102,88.566
		c-0.467,3.565-1.004,8.679-1.309,14.993"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M350.792,103.566
		c-0.016,0.347-0.032,0.697-0.048,1.051c-0.277,0.042-0.587,0.091-0.929,0.143"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="347.99"
          y1="105.042"
          x2="347.982"
          y2="105.043"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.815,1.805"
          d="
		M347.982,105.043c-11.526,1.787-42.535,6.71-50.23,9.113c-9.112,2.843-26.549,5.266-26.719,5.287
		c-0.169,0.02-4.098,0.47-7.118,0.799"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M263.908,120.242
		c-0.326,0.035-0.642,0.07-0.941,0.101l0.094-1.043"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="263.253"
          y1="117.143"
          x2="263.254"
          y2="117.132"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.92,1.91,0.01,0"
          x1="263.254"
          y1="117.131"
          x2="265.578"
          y2="91.1"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="265.579"
          y1="91.1"
          x2="265.673"
          y2="90.056"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M232.344,89.012
		c-0.042,0.324-0.083,0.671-0.125,1.039"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="231.996"
          y1="92.202"
          x2="231.995"
          y2="92.209"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.919,1.908,0.01,0"
          d="
		M231.995,92.209c-0.787,8.219-1.541,22.337-1.712,25.234l-0.005,0.075c-0.022,0.249-0.045,0.497-0.067,0.748"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M230.211,118.271
		c-0.031,0.347-0.061,0.696-0.092,1.044c-0.284-0.042-0.594-0.089-0.929-0.14"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="227.315"
          y1="118.886"
          x2="227.309"
          y2="118.884"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.864,1.854,0.01,0"
          d="
		M227.309,118.884c-6.157-0.969-16.787-2.797-22.97-4.729c-8.108-2.531-41.284-7.738-52.052-9.394"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M152.277,104.76
		c-0.332-0.051-0.643-0.099-0.931-0.142c-0.015-0.351-0.032-0.7-0.049-1.048"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="151.179"
          y1="101.488"
          x2="151.178"
          y2="101.474"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.847,1.837"
          d="
		M151.178,101.474c-0.437-6.883-1.261-13.213-1.766-16.654"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M149.412,84.822
		c-0.056-0.379-0.107-0.723-0.154-1.03"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M343.595,221.592
		c-0.212,0.041-0.54,0.106-0.928,0.182"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="340.828"
          y1="222.138"
          x2="340.821"
          y2="222.139"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.84,1.83"
          d="M340.822,222.139
		c-0.809,0.16-1.563,0.309-1.946,0.381c-3.985,0.749-8.185,1.506-12.514,2.259c-6.029,1.041-11.524,1.931-16.798,2.719
		c-6.776,1.006-12.309,1.722-17.412,2.253l-1.293,0.136c-1.06,0.111-2.155,0.228-3.199,0.287c-5.477,0.308-11.066,0.397-16.47,0.485
		l-0.218,0.003c-2.075,0.032-4.154,0.064-6.231,0.11c-0.778,0.016-1.564,0.02-2.354,0.025l-0.105,0.001
		c-1.205,0.009-2.394,0.023-3.575,0.067"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M258.7,230.867
		c-0.315,0.011-0.629,0.025-0.942,0.042c0.01-0.353,0.02-0.704,0.029-1.051"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.011,0"
          x1="257.852"
          y1="227.547"
          x2="257.852"
          y2="227.533"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="2.048,2.037,0.011,0"
          d="
		M257.852,227.534c0.166-5.941,0.304-10.802,0.393-13.945"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M258.244,213.594
		c0.011-0.373,0.021-0.722,0.03-1.045c0.293-0.011,0.608-0.023,0.941-0.034"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="261.096"
          y1="212.456"
          x2="261.108"
          y2="212.456"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.853,1.843,0.01,0"
          d="
		M261.108,212.455c6.116-0.177,15.462-0.335,15.887-0.337l0.065-0.002c12.768-0.709,53.271-5.009,63.253-6.083"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M340.313,206.033
		c0.35-0.037,0.663-0.07,0.935-0.101"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M30.221,263.136
		c0.249,0.156,0.523,0.327,0.82,0.512"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="32.597"
          y1="264.618"
          x2="32.604"
          y2="264.623"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.758,1.749"
          d="
		M32.604,264.622c4.288,2.662,11.454,7.055,18.939,11.403"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M51.548,276.029
		c0.279,0.162,0.557,0.324,0.836,0.485c-0.182,0.287-0.363,0.573-0.545,0.857"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="50.754"
          y1="279.067"
          x2="50.744"
          y2="279.081"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.844,1.834"
          d="
		M50.745,279.081c-2.624,4.088-5.036,7.747-6.641,10.165"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M44.107,289.241
		c-0.199,0.3-0.386,0.58-0.558,0.84c-0.274-0.167-0.548-0.336-0.826-0.504"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="41.061"
          y1="288.563"
          x2="41.054"
          y2="288.558"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.866,1.856,0.01,0"
          d="
		M41.054,288.559c-5.069-3.09-10.771-6.533-16.743-10.112"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M24.308,278.444
		c-0.277-0.166-0.553-0.331-0.83-0.497"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M65.187,303.806
		c-0.231-0.166-0.493-0.353-0.792-0.56"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="62.942"
          y1="302.259"
          x2="62.936"
          y2="302.254"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.678,1.669"
          d="
		M62.935,302.254c-2.626-1.756-7.084-4.607-14.893-9.414"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M48.036,292.837
		c-0.272-0.167-0.546-0.336-0.826-0.507c0.176-0.263,0.362-0.544,0.56-0.84"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="48.891"
          y1="289.798"
          x2="48.895"
          y2="289.792"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.861,1.851,0.01,0"
          d="
		M48.895,289.792c1.81-2.74,4.179-6.365,6.671-10.278"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M55.569,279.509
		c0.181-0.284,0.362-0.57,0.545-0.857c0.283,0.161,0.564,0.319,0.843,0.477"
        />
        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="58.492"
          y1="279.99"
          x2="58.5"
          y2="279.994"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.693,1.684"
          d="
		M58.501,279.994c6.783,3.787,12.05,6.45,15.734,7.956"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M74.231,287.949
		c0.305,0.125,0.6,0.242,0.884,0.352"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M161.097,205.933c10.45,1.055,48.741,5.26,63.143,6.21c-0.242,5.791-0.42,11.046-0.541,16.019c-0.022,0.939-0.047,1.88-0.075,2.824
		h-0.126c-16.766,0-54.172-7.175-64.201-9.093"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M228.716,230.724
		c-0.31-0.009-0.625-0.017-0.943-0.025c0.007-0.271,0.018-0.654,0.029-1.048"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="227.849"
          y1="227.8"
          x2="227.849"
          y2="227.79"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.641,1.632"
          d="M227.85,227.79
		c0.111-4.66,0.274-9.554,0.494-14.893"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M228.344,212.896
		c0.014-0.347,0.029-0.697,0.044-1.048c0.296,0,0.61,0.001,0.94,0.005"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="231.152"
          y1="211.882"
          x2="231.162"
          y2="211.882"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.798,1.788"
          d="
		M231.162,211.883c3.877,0.083,9.037,0.299,13.363,0.479c3.706,0.153,6.652,0.275,8.65,0.327"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M253.178,212.689
		c0.341,0.009,0.655,0.016,0.94,0.022l-0.03,1.048"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.011,0"
          x1="254.024"
          y1="216.085"
          x2="254.024"
          y2="216.097"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="2.062,2.051,0.011,0"
          d="
		M254.024,216.098l-0.006,0.213c-0.1,3.547-0.233,8.3-0.386,13.821"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M253.632,230.132
		c-0.01,0.347-0.019,0.697-0.029,1.051c-0.281,0.003-0.593,0.007-0.94,0.008"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="250.831"
          y1="231.189"
          x2="250.824"
          y2="231.189"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.805,1.795"
          d="
		M250.824,231.189c-3.372-0.022-9.815-0.126-22.101-0.464"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M152.559,300.481
		c0.25,0.169,0.518,0.349,0.805,0.536"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="155.007"
          y1="302.044"
          x2="155.013"
          y2="302.048"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.857,1.847,0.01,0"
          d="
		M155.013,302.048c8.438,5.089,28.208,14.307,65.745,18.842"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M220.768,320.891
		c0.312,0.037,0.626,0.075,0.94,0.112l-0.03,1.044"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.68,1.671"
          d="
		M221.624,323.948c-0.05,1.716-0.102,3.437-0.155,5.165c-0.108,3.347-0.223,6.715-0.343,10.083"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M221.125,339.205
		c-0.012,0.351-0.025,0.699-0.038,1.05c-0.314-0.042-0.627-0.084-0.939-0.127"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="218.33"
          y1="339.874"
          x2="218.32"
          y2="339.872"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.805,1.795"
          d="
		M218.32,339.872c-39.616-5.699-61.342-18.157-66.848-21.707"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M151.472,318.166
		c-0.325-0.21-0.594-0.389-0.806-0.533"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M225.215,340.775
		c-0.312-0.037-0.624-0.075-0.935-0.113c0.013-0.35,0.026-0.699,0.039-1.049"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="224.387"
          y1="337.7"
          x2="224.387"
          y2="337.686"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.695,1.686"
          d="
		M224.387,337.687c0.1-2.822,0.196-5.644,0.286-8.45c0.072-2.326,0.141-4.639,0.207-6.942"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M224.881,322.299
		c0.01-0.348,0.02-0.695,0.03-1.043c0.281,0.017,0.595,0.034,0.94,0.053"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="227.767"
          y1="321.416"
          x2="227.775"
          y2="321.417"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.89,1.88,0.01,0"
          d="
		M227.775,321.417c6.234,0.343,17.496,0.922,23.144,0.968"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M250.921,322.385
		c0.234,0.002,0.459,0.003,0.673,0.003c0.092,0,0.182,0,0.268-0.001v1.049"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="251.862"
          y1="325.349"
          x2="251.862"
          y2="325.36"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.695,1.686"
          x1="251.862"
          y1="325.36"
          x2="251.862"
          y2="340.752"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M251.862,340.752v1.049
		c-0.11,0-0.228,0.001-0.347,0.001c-0.186,0-0.384-0.001-0.591-0.002"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="248.957"
          y1="341.77"
          x2="248.945"
          y2="341.769"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.938,1.928,0.01,0"
          d="
		M248.945,341.769c-7.583-0.154-21.878-0.827-22.57-0.86c-0.386-0.043-0.772-0.089-1.156-0.134"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M223.314,384.812
		c0.026-0.347,0.049-0.696,0.072-1.045"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="223.502"
          y1="381.797"
          x2="223.502"
          y2="381.786"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.749,1.739"
          d="
		M223.502,381.787c0.237-4.493,0.298-9.031,0.355-13.161c0.05-3.725,0.103-7.074,0.229-10.322l0.046-1.129
		c0.144-3.66,0.288-7.369,0.429-11.096"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M224.561,346.079
		c0.013-0.35,0.027-0.698,0.04-1.048"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M350.405,320.281c-5.804,3.603-37.1,17.122-54.576,19.065c-13.472,1.496-28.133,1.922-36.01,2.151
		c-1.742,0.05-3.312,0.096-4.473,0.145l0.001-19.138c0.601,0.03,1.288,0.045,2.056,0.045c7.763,0,21.995-1.405,22.134-1.419
		c43.246-4.935,63.542-16.08,70.271-20.655"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M255.543,318.434v-0.279
		c0-0.208,0.001-0.463,0.004-0.765"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="255.576"
          y1="315.33"
          x2="255.577"
          y2="315.321"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.826,1.816"
          d="
		M255.577,315.321c0.205-12.02,1.301-52.542,2.022-78.732"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M257.6,236.58
		c0.009-0.352,0.019-0.7,0.029-1.048"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M282.148,207.142
		c0.073-0.321,0.148-0.661,0.225-1.016"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="282.791"
          y1="204.081"
          x2="282.793"
          y2="204.074"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.859,1.849,0.01,0"
          d="
		M282.793,204.074c3.793-19.253,10.539-71.877,11.993-83.339"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M294.787,120.728
		c0.05-0.395,0.094-0.741,0.131-1.035"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M352.514,81.705
		c-0.283-0.052-0.593-0.112-0.927-0.179"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="349.866"
          y1="81.172"
          x2="349.859"
          y2="81.171"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.724,1.715"
          d="M349.86,81.17
		c-3.793-0.806-9.288-2.119-13.72-3.5"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M336.133,77.669
		c-0.307-0.095-0.609-0.192-0.906-0.288c0.023-0.236,0.066-0.604,0.116-1.039"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.012,0"
          d="M335.58,73.895
		c0.001-0.005,0.001-0.01,0.001-0.016"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M335.581,73.88
		c0.026-0.388,0.04-0.749,0.034-1.049"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M332.058,72.918
		c0.012,0.354,0.021,0.707,0.028,1.05"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="332.094"
          y1="75.287"
          x2="332.094"
          y2="75.298"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M332.094,75.293
		c-0.003,0.378-0.01,0.731-0.021,1.048c-0.301-0.099-0.603-0.196-0.905-0.292"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.011,0"
          x1="329.224"
          y1="75.446"
          x2="329.212"
          y2="75.443"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.987,1.976,0.011,0"
          d="
		M329.212,75.443c-4.021-1.215-7.996-2.211-11.872-2.979"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M317.339,72.464
		c-0.31-0.061-0.619-0.12-0.927-0.179l-0.154-1.034"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="316.098"
          y1="70.167"
          x2="316.098"
          y2="70.161"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.972,0.967"
          x1="316.098"
          y1="70.161"
          x2="315.777"
          y2="67.983"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="315.776"
          y1="67.983"
          x2="315.623"
          y2="66.948"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="M312.144,64.48
		l0.93,7.227c-2.115-0.33-4.143-0.582-6.042-0.751c-0.392-0.035-0.827-0.053-1.293-0.053c-3.383,0-8.058,0.918-11.236,1.646
		c0.578-3.48,1.119-9.896,1.213-12.767"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M285.387,27.942c-2.207,3.866-8.237,12.378-17.766,17.514c0.102,5.344-0.53,23.564-0.538,23.75l-0.001,0.03l-1.701,18.931
		l2.686-0.639c11.082-3.417,21.027-12.038,22.86-13.686c0,0,1.032-0.489,1.97-0.489"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M228.59,207.237c0.284-6.254,0.609-12.469,0.952-19.017l0.034-0.638c0.206-3.909,0.413-7.836,0.616-11.794
		c0.135-2.754,0.428-5.566,0.712-8.285l0.007-0.073c0.262-2.552,0.533-5.191,0.684-7.805l0.309-5.337
		c0.694-12.004,1.412-24.418,2.503-36.364l0.008-0.117c0.137-2.322,1.367-22.831,2.306-27.8c1.028-5.449,3.205-27.659,2.753-31.178
		c-0.248-1.96-0.725-7.248-1.023-10.928c3.432,1.412,7.089,2.426,10.899,3.024l1.524,0.191l0.176,0.024l0.246-0.035l0.181-0.022
		c0.403-0.05,0.817-0.101,1.249-0.16c3.945-0.616,9.424-2.711,12.945-4.19"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="M233.43,87.249
		c-10.552-3.749-20.391-11.832-22.276-13.432c-0.798-2.632-1.207-9.226-1.316-14.276c0,0-0.966-0.803-1.435-0.803"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M217.528,29.021c2.217,3.881,7.454,11.36,17.054,16.494"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M186.341,65.524l-0.667,6.761c-5.089,0.964-10.348,2.326-15.658,4.056c-0.033-0.916,0.322-3.797,0.364-5.075"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M206.526,59.782c0.093,2.871,0.48,9.285,1.058,12.768c-3.177-0.729-7.853-1.646-11.25-1.646c-0.46,0-0.891,0.017-1.28,0.051
		c-1.9,0.17-3.927,0.422-6.043,0.751l1.086-7.226"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M166.779,74.212c-0.021,1.295,0.004,2.345,0.081,3.169c-5.725,1.86-13.554,3.655-17.133,4.324"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M210.619,300.09c-9.144-1.444-40.887-11.033-46.752-12.817c-1.306-2.627-2.2-5.038-2.207-5.656c0-1.073,0.597-9.75,1.643-23.92
		c11.863,4.483,46.416,13.727,53.366,15.573l-1.479,22.823L210.619,300.09z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M285.417,296.979l-0.996-22.857c7.802-1.859,41.861-10.053,53.68-14.173c1.058,20.061,1.148,23.442,1.139,23.954
		c-0.022,0.624-0.968,3.013-2.329,5.596c-4.925,1.361-37.705,10.369-47.011,11.588L285.417,296.979z"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          points="
		262.967,122.679 260.379,165.261 258.396,209.673 	"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M149.493,354.431c0,0,0.231,0.196,0.797,0.549"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="151.93"
          y1="355.901"
          x2="151.937"
          y2="355.904"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.811,1.801"
          d="
		M151.937,355.904c5.749,2.95,23.251,9.697,68.817,14.309"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M220.769,370.215
		c0.311,0.032,0.625,0.064,0.939,0.094"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M252.285,371.959c0,0,64.084-0.041,100.072-17.015"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          x1="227.773"
          y1="235.269"
          x2="225.302"
          y2="318.676"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M51.15,330.682
		c-0.101-0.024-0.444-0.133-0.908-0.283"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          d="M48.388,329.789
		c-0.005-0.001-0.01-0.003-0.016-0.005"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.906,1.896,0.01,0"
          d="
		M48.372,329.784c-0.994-0.331-1.927-0.647-2.172-0.736c-0.041-0.018-0.121-0.048-0.202-0.077l-0.138-0.051
		c-0.767-0.296-1.671-0.691-2.761-1.204l-0.57-0.277c-3.59-1.746-8.542-4.551-14.327-8.113c-0.179-0.11-1.276-0.79-1.276-0.79
		c-0.277-0.17-0.552-0.343-0.828-0.518c-0.224-0.137-1.064-0.664-1.273-0.795c-0.113-0.074-0.794-0.51-0.794-0.51
		c-1.175-0.745-2.345-1.495-3.502-2.245"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M20.532,314.471
		c-0.273-0.176-0.543-0.353-0.814-0.529l0.485-0.9"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="21.151"
          y1="311.285"
          x2="21.156"
          y2="311.275"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.815,1.805"
          x1="21.156"
          y1="311.275"
          x2="32.595"
          y2="290.072"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M32.595,290.073l0.485-0.899
		c0.03,0.018,0.4,0.242,0.825,0.499"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="35.495"
          y1="290.639"
          x2="35.503"
          y2="290.644"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.784,1.774"
          d="
		M35.503,290.644l6.079,3.704l3.644,2.233c4.492,2.767,8.242,5.107,11.143,6.951c0.186,0.121,0.387,0.25,0.589,0.378
		c0.118,0.077,0.233,0.149,0.341,0.216c0.081,0.051,0.175,0.113,0.27,0.175c2.453,1.572,5.019,3.408,6.403,4.409"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M63.976,308.71
		c0.341,0.247,0.61,0.444,0.787,0.571"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M153.997,110.894
		c-0.063-0.342-0.128-0.686-0.191-1.032c0.299,0.047,0.609,0.094,0.931,0.145"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="156.642"
          y1="110.306"
          x2="156.652"
          y2="110.307"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.896,1.886,0.01,0"
          d="
		M156.652,110.307c13.305,2.09,39.817,6.391,46.564,8.498c4.002,1.249,9.691,2.429,14.43,3.304"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M217.649,122.111
		c0.314,0.058,0.625,0.115,0.93,0.17l-0.203,1.024"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="217.966"
          y1="125.375"
          x2="217.964"
          y2="125.386"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.877,1.867,0.01,0"
          d="
		M217.964,125.386l-2.504,12.641l-5.437,4.748l-45.061,0.506l-4.543-3.786c-0.795-2.822-3.482-12.796-6.423-28.602"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M425.523,289.666
		c0.277-0.11,0.572-0.229,0.883-0.359"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="428.19"
          y1="288.54"
          x2="428.196"
          y2="288.537"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.883,1.873,0.01,0"
          d="
		M428.196,288.537c4.305-1.906,10.728-5.094,17.414-9.039"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M445.616,279.494
		c0.277-0.163,0.555-0.328,0.832-0.495c0.176,0.293,0.351,0.582,0.527,0.872"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="448.061"
          y1="281.659"
          x2="448.067"
          y2="281.669"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.912,1.901,0.01,0"
          d="
		M448.067,281.669c2.275,3.722,4.506,7.244,6.742,10.646"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M454.809,292.316
		c0.186,0.281,0.371,0.563,0.557,0.845c-0.284,0.159-0.566,0.314-0.843,0.469"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="452.84"
          y1="294.563"
          x2="452.831"
          y2="294.569"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.851,1.841,0.01,0"
          d="
		M452.831,294.569c-8.946,4.951-14.457,7.818-16.951,9.307"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M435.88,303.876
		c-0.323,0.193-0.596,0.363-0.819,0.511"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M481.603,279.008
		c-0.268,0.145-0.55,0.297-0.846,0.456"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="479.167"
          y1="280.316"
          x2="479.159"
          y2="280.32"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.738,1.729"
          d="
		M479.159,280.32c-5.002,2.669-12.589,6.644-19.184,10.277"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M459.971,290.599
		c-0.283,0.157-0.565,0.311-0.844,0.467c-0.186-0.28-0.372-0.562-0.558-0.843"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="457.413"
          y1="288.46"
          x2="457.408"
          y2="288.453"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.932,1.921,0.01,0"
          d="
		M457.408,288.453c-2.234-3.43-4.474-6.999-6.772-10.79"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M450.634,277.659
		c-0.176-0.288-0.351-0.579-0.527-0.871c0.275-0.167,0.549-0.335,0.826-0.504"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="452.581"
          y1="275.274"
          x2="452.589"
          y2="275.27"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.853,1.843,0.01,0"
          d="
		M452.589,275.27c7.731-4.749,15.772-9.831,19.754-12.433"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M472.346,262.836
		c0.291-0.191,0.561-0.368,0.807-0.531"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M471.745,257.607
		c-0.233,0.154-0.502,0.333-0.807,0.535"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="469.244"
          y1="259.255"
          x2="469.236"
          y2="259.261"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.939,1.929,0.01,0"
          d="
		M469.237,259.26c-4.598,3.021-12.989,8.486-20.602,13.153"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M448.628,272.417
		c-0.277,0.168-0.551,0.337-0.826,0.504c-0.172-0.291-0.343-0.581-0.513-0.875"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="446.283"
          y1="270.326"
          x2="446.279"
          y2="270.319"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.817,1.807"
          d="
		M446.279,270.319c-1.942-3.34-3.927-6.842-5.934-10.47"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M440.342,259.845
		c-0.164-0.297-0.329-0.595-0.493-0.894c0.273-0.169,0.548-0.339,0.823-0.51"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="442.35"
          y1="257.397"
          x2="442.358"
          y2="257.391"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.893,1.883,0.01,0"
          d="
		M442.358,257.392c7.889-4.913,15.966-10.063,20.13-12.818"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M462.49,244.572
		c0.288-0.19,0.557-0.369,0.806-0.536"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M414.008,273.265
		c0.277-0.125,0.567-0.259,0.868-0.4"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="416.481"
          y1="272.099"
          x2="416.488"
          y2="272.096"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.721,1.712"
          d="
		M416.488,272.096c4.832-2.355,11.779-6.125,18.89-10.411"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M435.383,261.682
		c0.277-0.166,0.552-0.334,0.829-0.501c0.164,0.299,0.329,0.597,0.493,0.893"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="437.672"
          y1="263.816"
          x2="437.678"
          y2="263.827"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.813,1.804"
          d="
		M437.678,263.826c2.048,3.676,4.018,7.126,5.953,10.429"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M443.631,274.255
		c0.172,0.293,0.343,0.585,0.514,0.875c-0.28,0.167-0.556,0.331-0.832,0.495"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="441.587"
          y1="276.643"
          x2="441.577"
          y2="276.649"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.925,1.914,0.01,0"
          d="
		M441.577,276.649c-8.741,5.118-14.817,8.165-17.759,9.336"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M423.818,285.985
		c-0.339,0.135-0.637,0.245-0.892,0.33"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M220.558,26.709
		c0.28-0.099,0.58-0.201,0.898-0.308"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="223.309"
          y1="25.817"
          x2="223.314"
          y2="25.816"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.898,1.888,0.01,0"
          d="
		M223.315,25.815c6.455-1.946,17.685-4.486,27.823-4.627c11.092,0.18,23.548,3.248,29.488,5.214"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M280.632,26.405
		c0.318,0.106,0.619,0.208,0.898,0.307"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="493.166"
          y1="299.965"
          x2="492.346"
          y2="300.483"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="490.86"
          y1="301.42"
          x2="490.851"
          y2="301.425"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.683,1.674"
          x1="490.852"
          y1="301.425"
          x2="484.873"
          y2="305.195"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          points="484.872,305.195 484.051,305.712 
		483.566,304.813 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="482.793"
          y1="303.378"
          x2="482.788"
          y2="303.37"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.481,1.473"
          x1="482.789"
          y1="303.37"
          x2="479.676"
          y2="297.603"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          points="479.676,297.603 479.19,296.704 
		480.007,296.179 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="481.468"
          y1="295.241"
          x2="481.476"
          y2="295.235"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.662,1.653"
          x1="481.476"
          y1="295.235"
          x2="487.35"
          y2="291.46"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="487.349"
          y1="291.46"
          x2="488.166"
          y2="290.935"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M437.947,308.759c3.816-2.495,16.384-9.964,32.712-18.904l12.494,23.158c-1.969,1.199-4.015,2.438-6.034,3.635
		c-3.734,2.218-8.145,4.796-12.555,7.106l-0.794,0.421c-2.72,1.43-9.416,4.282-12.209,4.942"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="17.836"
          y1="291.29"
          x2="17.844"
          y2="291.296"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.689,1.68"
          x1="17.844"
          y1="291.295"
          x2="23.812"
          y2="295.134"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          points="23.813,295.134 24.628,295.66 
		24.143,296.559 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="23.37"
          y1="297.993"
          x2="23.366"
          y2="298.001"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.481,1.473"
          x1="23.366"
          y1="298.001"
          x2="20.256"
          y2="303.768"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          points="20.256,303.768 19.771,304.667 
		18.95,304.15 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="17.489"
          y1="303.227"
          x2="17.48"
          y2="303.223"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.655,1.646"
          x1="17.481"
          y1="303.223"
          x2="11.602"
          y2="299.513"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M79.111,284.91
		c-0.274-0.09-0.573-0.195-0.896-0.314"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="76.457"
          y1="283.899"
          x2="76.45"
          y2="283.896"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.838,1.828"
          d="M76.45,283.896
		c-3.987-1.666-10.187-4.729-17.086-8.596"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M59.358,275.296
		c-0.28-0.158-0.56-0.314-0.842-0.474c0.181-0.292,0.359-0.58,0.537-0.866"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="60.052"
          y1="272.332"
          x2="60.057"
          y2="272.323"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.743,1.733"
          d="
		M60.057,272.323c2.407-3.937,4.345-7.273,5.793-9.972"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M65.849,262.353
		c0.165-0.308,0.325-0.608,0.477-0.9c0.278,0.167,0.553,0.335,0.83,0.499"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.011,0"
          x1="68.899"
          y1="262.991"
          x2="68.912"
          y2="262.999"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.948,1.937,0.011,0"
          d="
		M68.911,262.998c7.028,4.143,13.582,7.553,17.92,9.571"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M86.829,272.568c0.3,0.14,0.591,0.272,0.87,0.4
		"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M38.696,243.617
		c0.25,0.167,0.518,0.347,0.804,0.54"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.011,0"
          x1="41.199"
          y1="245.293"
          x2="41.204"
          y2="245.298"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.953,1.942,0.011,0"
          d="
		M41.205,245.298c4.915,3.288,12.983,8.65,20.657,13.414"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M61.87,258.717
		c0.275,0.17,0.549,0.341,0.824,0.51c-0.153,0.291-0.312,0.59-0.479,0.898"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          x1="61.282"
          y1="261.82"
          x2="61.279"
          y2="261.827"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.76,1.751"
          d="M61.279,261.827
		c-1.541,2.754-3.53,6.096-5.949,9.997"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M55.326,271.829
		c-0.177,0.285-0.356,0.574-0.538,0.865c-0.278-0.16-0.556-0.321-0.836-0.484"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="52.226"
          y1="271.2"
          x2="52.218"
          y2="271.196"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.921,1.911,0.01,0"
          d="
		M52.218,271.196c-8.363-4.917-16.938-10.341-20.609-12.65"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M31.606,258.544
		c-0.308-0.194-0.582-0.366-0.819-0.513"
        />
        <path
          d="M494.53,300.205c-1.127-2.032-2.253-4.061-3.38-6.092c-2.544-4.594-4.768-8.638-6.802-12.365
		c-2.004-3.665-4.131-7.579-6.238-11.583c-0.267-0.516-0.568-1.043-0.872-1.581c-0.813-1.436-1.659-2.923-2.08-4.405
		c-1.624-5.705-5.141-11.478-8.243-16.573l-0.596-0.982c-2.23-3.669-4.571-7.337-6.844-10.882c-1.601-2.51-3.263-5.105-4.863-7.672
		c-7.702-12.356-15.378-24.982-22.818-37.529c-2.634-4.447-5.262-9.004-7.797-13.41c-8.224-14.271-16.726-29.026-26.879-42.232
		l-2.516-3.273c-2.15-2.803-4.305-5.601-6.459-8.399c-3.685-4.791-6.539-8.476-9.244-11.957c-3.393-4.359-6.159-7.882-8.703-11.082
		c-2.146-2.698-4.694-5.888-7.351-9.066l-0.033-0.042c-1.648-1.973-3.352-4.014-5.173-5.872l-0.197-0.199
		c-0.46-0.474-0.977-1.007-1.587-1.372c-0.052-0.068-0.107-0.136-0.174-0.203l-0.009-0.032c-0.004-0.005-0.009-0.005-0.009-0.01
		c-0.127-0.115-0.245-0.251-0.357-0.381c-0.014-0.015-0.017-0.036-0.033-0.052l-0.023-0.005c-1.779-1.9-5.346-5.08-8.449-6.525
		c-6.135-2.866-32.868-14.203-52.42-17.773c-0.994-3.921-1.99-8.143-2.951-12.23c-3.376-14.329-5.018-20.702-6.615-21.609
		c-2.197-1.243-18.302-6.4-33.572-6.671V18.14c-15.378,0.183-31.733,5.408-33.971,6.677c-1.596,0.907-3.239,7.281-6.609,21.598
		c-0.963,4.092-1.958,8.32-2.953,12.241c-19.551,3.57-46.289,14.906-52.424,17.773c-3.102,1.445-6.67,4.624-8.449,6.525h-0.014
		v0.005c-0.028,0.042-0.06,0.084-0.089,0.126c-0.005,0.005-0.005,0.02-0.014,0.026c-0.004,0.01-0.014,0.015-0.018,0.02
		c-0.047,0.062-0.099,0.126-0.155,0.177c-0.042,0.042-0.094,0.084-0.141,0.126c-0.061,0.073-0.122,0.141-0.179,0.209
		c-0.042,0.026-0.084,0.052-0.121,0.078c-0.587,0.402-1.084,0.913-1.568,1.403l-0.09,0.09c-0.84,0.86-1.633,1.748-2.365,2.584
		c-0.901,1.023-1.864,2.156-3.037,3.56c-1.089,1.31-2.267,2.746-3.595,4.389c-1.362,1.681-2.709,3.372-4.057,5.063
		c-1.469,1.859-2.934,3.717-4.398,5.586c-1.55,1.977-3.093,3.956-4.634,5.94c-1.586,2.045-3.173,4.098-4.759,6.149
		c-1.591,2.061-3.183,4.128-4.769,6.19c-1.563,2.031-3.122,4.056-4.675,6.081l-4.469,5.815c-1.38,1.796-2.764,3.59-4.15,5.382
		c-1.207,1.565-2.427,3.116-3.642,4.661c-3.516,4.463-7.154,9.078-10.398,13.998c-3.816,5.795-7.59,12.23-11.532,19.678
		c-0.62,1.169-1.239,2.344-1.855,3.519c-1.211,2.301-2.459,4.682-3.717,7.004c-2.16,3.989-4.141,7.434-6.057,10.528
		c-3.393,5.476-6.849,11.39-10.191,17.111c-2.595,4.436-5.276,9.024-7.857,13.283c-3.422,5.643-6.901,11.876-10.642,19.047
		c-0.624,1.195-1.332,2.416-2.084,3.711c-1.808,3.116-3.68,6.342-4.634,9.688c-0.685,2.405-15.748,32.058-19.344,38.505
		c-0.699,1.257-0.995,2.714-0.836,4.102c0.108,0.897,0.366,1.587,0.775,2.041c1.44,1.602,34.116,23.65,41.088,23.645
		c0.085,0,0.164,0,0.244-0.01c6.328-0.548,16.946-23.524,18.256-26.401c0.601-0.944,1.202-1.884,1.807-2.824
		c1.141-1.774,2.278-3.564,3.418-5.355c5.239-8.231,10.655-16.744,16.716-24.313c6.825-8.512,14.383-16.702,21.691-24.616
		c5.751-6.226,11.698-12.662,17.265-19.239c3.46-4.088,6.534-8.534,9.505-12.835c2.023-2.929,4.113-5.956,6.301-8.831
		c0.882-1.154,1.825-2.261,2.806-3.336c0.127,0.01,0.254,0.026,0.381,0.036l0.029-0.47c2.591-2.771,5.445-5.308,8.238-7.782
		c2.032-1.8,4.112-3.654,6.087-5.585c-0.774,7.516-3.628,34.768-4.802,41.465c-3.164,18.086-4.322,36.882-5.44,55.061
		c-0.291,4.746-0.596,9.652-0.925,14.455c-0.192,2.719-0.563,20.257-0.61,24.694c-0.009,1.262-0.154,4.677-0.338,9.003
		c-0.647,15.383-1.178,29.371-0.553,31.486c0.141,0.489,0.267,0.95,0.385,1.383c0.609,2.234,1.094,3.999,3.122,5.982
		c2.676,2.621,46.068,12.011,70.759,13.19c4.493,0.215,8.159,0.412,11.35,0.579c5.709,0.308,9.83,0.533,14.473,0.631h2.83
		c5.483-0.135,12.482-0.479,20.584-0.876c2.244-0.11,4.562-0.219,6.952-0.334c24.686-1.179,68.079-10.569,70.759-13.19
		c2.023-1.983,2.506-3.748,3.117-5.982c0.117-0.432,0.244-0.893,0.39-1.383c0.625-2.115,0.095-16.103-0.558-31.486
		c-0.184-4.326-0.324-7.74-0.338-9.003c-0.047-4.433-0.418-21.96-0.605-24.694c-0.244-3.483-0.428-7.047-0.606-10.492
		c-0.253-4.813-0.511-9.786-0.929-14.678c-1.445-16.973-3.54-34.131-5.563-50.728c-1.399-11.484-2.844-23.332-4.065-35.062
		c1.751,1.744,3.543,3.429,5.295,5.068c4.018,3.764,8.172,7.658,11.725,12.214c1.822,2.334,3.591,4.708,5.305,7.005
		c3.294,4.411,6.698,8.973,10.481,13.28l18.12,20.653c2.24,2.553,4.563,5.126,6.816,7.61c6.327,6.995,12.871,14.229,18.41,22.049
		c6.426,9.072,12.496,18.466,18.096,27.267c1.375,2.621,12.937,24.288,19.255,24.835c0.639,0.058,1.25-0.067,1.774-0.193
		c3.113-0.73,6.066-2.291,8.924-3.794l0.789-0.419c4.501-2.354,8.932-4.948,12.679-7.172c3.201-1.905,6.435-3.878,9.566-5.783
		l2.206-1.346c0.681-0.418,1.366-0.831,2.047-1.243l0.253-0.145c0.643-0.376,1.305-0.768,1.794-1.577
		c0.112-0.183,0.216-0.386,0.318-0.616C495.864,305.784,495.84,302.559,494.53,300.205 M487.92,291.091
		c0.231,0.417,0.466,0.84,0.7,1.268c0.226,0.408,0.45,0.82,0.681,1.237c0.239,0.422,0.479,0.856,0.718,1.294
		c0.963,1.744,1.93,3.487,2.901,5.231c0.159,0.287,0.319,0.574,0.479,0.86c0.113,0.204,0.207,0.418,0.296,0.632l-10.154,6.195
		l-6.303-11.682l10.011-6.253C487.47,290.276,487.696,290.679,487.92,291.091 M483.208,282.516c1.056,1.937,2.168,3.956,3.343,6.097
		l-9.999,6.248l-4.155-7.705c0.591-0.324,1.183-0.647,1.77-0.965c0.591-0.324,1.178-0.642,1.764-0.96
		c0.695-0.381,1.386-0.751,2.071-1.123c0.465-0.255,0.925-0.502,1.379-0.751c0.07-0.036,0.137-0.074,0.207-0.11
		c0.498-0.271,0.985-0.538,1.469-0.798c0.554-0.297,1.098-0.59,1.633-0.882C482.865,281.883,483.04,282.207,483.208,282.516
		 M472.651,261.098c0.057,0.136,0.109,0.272,0.164,0.409c0.089,0.218,0.174,0.443,0.258,0.663c0.019,0.052,0.039,0.099,0.057,0.15
		c0.051,0.137,0.098,0.267,0.145,0.403c0.009,0.025,0.018,0.047,0.029,0.073c0.099,0.282,0.197,0.569,0.286,0.85
		c0.108,0.33,0.206,0.654,0.3,0.982c0.475,1.665,1.362,3.231,2.22,4.745c0.296,0.527,0.587,1.039,0.854,1.54
		c0.366,0.704,0.738,1.398,1.109,2.093c0.183,0.348,0.365,0.699,0.553,1.044c0.184,0.343,0.367,0.688,0.549,1.027
		c0.737,1.373,1.469,2.73,2.192,4.056c0.211,0.392,0.423,0.778,0.634,1.163c-2.699,1.462-12.612,6.833-22.466,12.293
		c-0.282,0.156-0.558,0.312-0.836,0.464c-3.492-5.215-7.008-10.784-10.618-16.818c10.979-6.65,21.795-13.812,24.4-15.544
		C472.543,260.827,472.6,260.963,472.651,261.098 M463.164,244.125c0.347,0.554,0.69,1.107,1.033,1.665
		c0.338,0.553,0.681,1.107,1.019,1.66l0.6,0.986c0.258,0.428,0.522,0.856,0.785,1.295c0.281,0.459,0.563,0.929,0.844,1.398
		c0.253,0.417,0.502,0.84,0.751,1.268c0.248,0.418,0.492,0.841,0.732,1.263c0.155,0.261,0.305,0.527,0.45,0.793
		c0.193,0.345,0.385,0.689,0.574,1.039c0.221,0.402,0.436,0.815,0.647,1.221c0.215,0.406,0.423,0.82,0.625,1.232
		c0.229,0.47,0.454,0.94,0.671,1.41c-2.313,1.54-13.396,8.869-24.555,15.633c-3.074-5.178-6.215-10.695-9.458-16.615
		c11.107-6.838,21.574-13.842,24.362-15.716C462.549,243.144,462.86,243.634,463.164,244.125 M334.323,72.712
		c0.437,0.171,0.865,0.344,1.287,0.512c0.084,0.036,0.168,0.067,0.253,0.103c0.333,0.136,0.663,0.267,0.986,0.402
		c0.273,0.115,0.539,0.225,0.807,0.335c0.262,0.104,0.521,0.213,0.779,0.318c0.249,0.104,0.493,0.204,0.728,0.303
		c0.591,0.245,1.155,0.48,1.689,0.709c0.268,0.115,0.53,0.225,0.784,0.335c0.127,0.057,0.254,0.109,0.376,0.161
		c0.033,0.016,0.065,0.026,0.094,0.042c0.215,0.094,0.427,0.183,0.629,0.271c0.235,0.1,0.46,0.199,0.676,0.292
		c0.18,0.079,0.348,0.152,0.512,0.225c0.145,0.068,0.286,0.131,0.423,0.188c0.191,0.089,0.38,0.173,0.558,0.25
		c0.089,0.043,0.178,0.079,0.262,0.12c0.061,0.026,0.122,0.052,0.178,0.078c0.203,0.089,0.39,0.177,0.569,0.261
		c0.065,0.032,0.132,0.058,0.192,0.089c0.066,0.026,0.127,0.058,0.184,0.084c0.159,0.074,0.32,0.151,0.484,0.24
		c0.013,0.006,0.022,0.011,0.038,0.022c0.116,0.057,0.239,0.119,0.355,0.188c0.297,0.167,0.593,0.344,0.888,0.531
		c0.15,0.089,0.296,0.188,0.446,0.287c0.146,0.1,0.295,0.199,0.441,0.303c0.225,0.157,0.455,0.319,0.676,0.486
		c0.018,0.016,0.038,0.026,0.057,0.042c0.197,0.145,0.389,0.292,0.577,0.443c0.065,0.052,0.132,0.106,0.197,0.157
		c0.215,0.173,0.432,0.351,0.643,0.518l0.014,0.015c0.211,0.177,0.418,0.355,0.62,0.532c0.004,0,0.004,0,0.009,0.006
		c0.442,0.381,0.86,0.757,1.239,1.117c-3.295-0.48-10.294-1.722-18.796-4.552C334.343,77.263,334.447,75.687,334.323,72.712
		 M354.161,84.325c-0.418,2.437-1.624,10.241-2.051,21.348c-0.005,0.104-0.013,0.215-0.018,0.319
		c-5.558,0.846-45.167,6.927-53.96,9.671c-9.167,2.86-26.769,5.313-26.934,5.335c-0.081,0.01-7.276,0.835-9.802,1.081l2.788-31.042
		l1.432-0.344l2.994-0.715c12.032-3.7,22.697-13.216,23.969-14.38c1.253-0.319,9.975-2.511,14.274-2.125
		c8.032,0.715,17.106,2.734,26.25,5.841C343.435,82.822,351.711,84.022,354.161,84.325 M339.244,189.422
		c0.46,4.489,0.952,8.994,1.464,13.493c-5.384,0.585-44.087,4.745-60.45,5.94c3.496-12.214,12.476-83.092,13.4-90.456
		c1.751-0.423,3.395-0.862,4.831-1.31c8.464-2.641,47.219-8.628,53.509-9.589c-0.601,7.799-3.08,18.134-5.291,27.336
		c-1.68,6.989-3.131,13.023-3.558,17.027c-1.028,9.583-3.906,36.845-3.934,37.117l-0.042,0.376L339.244,189.422z M224.044,318.677
		c0.432-15.778,0.728-31.052,0.986-45.396c0.146-8.247,0.455-16.766,0.751-25.008c0.174-4.79,0.351-9.702,0.497-14.573
		c4.882,0.142,18.964,0.532,25.691,0.532c1.305,0,2.328-0.015,2.957-0.048c-0.835,30.119-2.126,77.857-2.126,83.969v1.696
		C247.595,320.003,228.617,318.943,224.044,318.677 M252.801,321.329v20.775l-0.029,0.724c-4.558,0.162-26.268-0.866-26.465-0.876
		c-1.01-0.116-2.009-0.235-3-0.361c0.15-4.133,0.296-8.278,0.428-12.391c0.094-3.032,0.183-6.044,0.267-9.04
		c4.417,0.255,21.044,1.185,27.591,1.185C252.05,321.344,252.449,321.339,252.801,321.329 M162.833,189.146
		c0.009-0.465-0.103-1.561-0.427-4.604l-1.109-10.486c-0.854-8.07-1.84-17.35-2.36-22.194c-0.428-4.004-1.878-10.038-3.555-17.027
		c-2.21-9.202-4.694-19.537-5.294-27.336c0.163,0.022,0.342,0.053,0.548,0.084c3.746,21.041,7.342,33.212,7.376,33.338l0.065,0.219
		l5.98,4.984l46.928-0.527l6.934-6.06l3.675-18.518c4.529,0.782,8.309,1.341,9.661,1.534c-0.878,10.596-1.503,21.458-2.113,32.013
		l-0.277,4.864c-0.15,2.563-0.423,5.189-0.686,7.726c-0.286,2.771-0.581,5.637-0.727,8.461c-0.197,3.957-0.404,7.877-0.61,11.786
		c-0.381,7.282-0.751,14.349-1.066,21.416c-14.181-0.835-58.33-5.293-64.347-5.904c0.817-7.594,1.432-13.623,1.445-13.763
		L162.833,189.146z M152.032,107.798c10.002,1.545,43.739,6.848,51.564,9.291c4.417,1.378,10.988,2.698,16.678,3.7l-3.548,17.914
		l-6.211,5.422l-46.016,0.518l-5.286-4.407C158.721,138.526,155.454,126.902,152.032,107.798 M226.322,232.224
		c0.042-1.456,0.08-2.908,0.116-4.348c0.142-5.946,0.353-11.766,0.606-17.581c3.483-0.083,10.914,0.225,17.532,0.502
		c5.06,0.208,8.619,0.354,10.351,0.354c0.258,0,0.47-0.006,0.643-0.01c-0.09,3.262-0.32,11.284-0.601,21.563
		C251.623,232.929,232.237,232.391,226.322,232.224 M244.628,209.32c-6.572-0.277-13.946-0.579-17.519-0.506
		c0.309-7.031,0.681-14.072,1.061-21.322c0.207-3.909,0.413-7.835,0.616-11.792c0.136-2.776,0.431-5.627,0.718-8.377
		c0.263-2.557,0.535-5.199,0.686-7.798l0.282-4.864c0.703-12.173,1.426-24.763,2.534-36.892c0.014-0.225,1.324-22.722,2.338-28.082
		c1.076-5.701,3.141-27.498,2.737-30.635c-0.324-2.568-1.009-10.444-1.225-13.54c3.629,1.717,7.83,3.1,12.694,3.863
		c0.487,0.062,0.962,0.119,1.421,0.177l0.076,0.01l0.07-0.01c0.464-0.058,0.939-0.115,1.441-0.183
		c4.909-0.767,9.144-2.171,12.796-3.915c0.009,0.387,0.014,0.857,0.014,1.404c0,0.501-0.005,1.06-0.01,1.671
		c-0.004,0.266-0.004,0.532-0.009,0.814c-0.014,1.039-0.038,2.187-0.061,3.403c-0.009,0.36-0.013,0.725-0.023,1.097
		c-0.009,0.392-0.019,0.783-0.028,1.185c-0.01,0.396-0.019,0.798-0.034,1.205c-0.013,0.641-0.033,1.3-0.051,1.952
		c-0.009,0.422-0.019,0.85-0.034,1.268c-0.008,0.365-0.017,0.725-0.033,1.091c-0.009,0.438-0.022,0.877-0.033,1.305
		c-0.009,0.292-0.018,0.585-0.028,0.876c-0.019,0.574-0.034,1.133-0.052,1.681c-0.019,0.699-0.042,1.372-0.061,1.999
		c-0.008,0.225-0.013,0.444-0.022,0.653c-0.005,0.141-0.01,0.277-0.015,0.406c-0.004,0.204-0.013,0.402-0.018,0.59v0.058
		c-0.004,0.057-0.004,0.12-0.004,0.177c-0.01,0.271-0.019,0.527-0.029,0.767l-4.981,55.406c-0.018,0.355-1.877,35.504-2.338,39.084
		c-0.398,3.081-1.38,31.486-1.751,42.181c-0.076,2.119-0.122,3.512-0.136,3.821v0.109
		C254.411,209.727,249.651,209.529,244.628,209.32 M257.082,205.78c0.372-10.669,1.353-39.016,1.737-42.023
		c0.47-3.643,2.276-37.759,2.351-39.179l0.09-1.002c0.412-0.036,0.995-0.093,1.666-0.166c0.286-0.032,0.596-0.064,0.912-0.1
		c0.211-0.02,0.427-0.047,0.646-0.073c0.024,0,0.043-0.006,0.066-0.006c0.273-0.032,0.545-0.062,0.822-0.089
		c0.314-0.036,0.63-0.068,0.938-0.104h0.024c0.094-0.01,0.192-0.022,0.286-0.032c0.141-0.02,0.278-0.036,0.412-0.047
		c0.137-0.022,0.278-0.032,0.409-0.048c0.07-0.01,0.132-0.015,0.197-0.02c0.075-0.01,0.146-0.02,0.22-0.026
		c0.385-0.042,0.761-0.083,1.108-0.125c0.117-0.011,0.231-0.026,0.343-0.037c0.615-0.073,1.136-0.129,1.498-0.171
		c0.065-0.01,0.127-0.016,0.183-0.022c0.056-0.005,0.108-0.01,0.155-0.015c0.028-0.006,0.056-0.01,0.08-0.01
		c0.023-0.006,0.047-0.006,0.065-0.011c0.025,0,0.047-0.005,0.057-0.005c0.094-0.01,4.97-0.695,10.923-1.749l-10.435,82.23
		c-0.056,0.454,0.061,0.914,0.324,1.269c0.263,0.35,0.648,0.558,1.062,0.579c0.511,0.022,0.971,0.032,1.375,0.032
		c2.436,0,3.008-0.408,3.126-1.112c0.127-0.762,10.656-76.702,11.717-84.376c0.958-0.203,1.911-0.406,2.835-0.621
		c-1.202,9.494-10.289,80.742-13.448,90.232c-0.676,0.048-1.305,0.084-1.878,0.115c-0.033,0-0.093,0.006-0.187,0.006
		s-0.211,0.006-0.357,0.006c-0.137,0.006-0.291,0.006-0.47,0.01c-0.112,0-0.234,0.005-0.361,0.005
		c-0.183,0.006-0.375,0.006-0.587,0.011c-0.085,0-0.173,0.005-0.262,0.005c-0.132,0-0.267,0.006-0.404,0.006
		c-0.099,0-0.196,0.005-0.3,0.005c-0.249,0.006-0.506,0.011-0.775,0.016c-0.248,0.006-0.511,0.011-0.783,0.016
		c-0.268,0.006-0.545,0.01-0.827,0.016c-0.164,0.006-0.329,0.006-0.497,0.01h-0.019c-0.168,0.005-0.338,0.005-0.507,0.01
		c-0.149,0.006-0.3,0.006-0.45,0.011c-0.168,0-0.338,0.005-0.511,0.01c-0.441,0.01-0.887,0.016-1.338,0.026
		c-0.112,0.005-0.219,0.005-0.333,0.01c-0.272,0.006-0.544,0.01-0.821,0.016c-0.137,0.005-0.278,0.005-0.413,0.01
		c-0.183,0.005-0.366,0.01-0.545,0.01c-0.099,0.006-0.192,0.006-0.286,0.006c-0.267,0.01-0.536,0.015-0.802,0.02
		c-0.141,0.006-0.287,0.006-0.432,0.01c-0.582,0.016-1.156,0.026-1.719,0.042c-0.229,0.006-0.459,0.01-0.685,0.016
		c-0.356,0.01-0.704,0.02-1.042,0.031c-0.253,0.01-0.501,0.016-0.746,0.022c-0.728,0.026-1.404,0.047-2.009,0.068
		c-0.023,0.005-0.047,0.005-0.07,0.005c-0.558,0.016-1.046,0.036-1.456,0.058C256.964,209.174,257.011,207.817,257.082,205.78
		 M285.275,126.306c-0.038,0-0.065-0.015-0.099-0.02h-0.014c-0.121,0-0.215-0.047-0.295-0.109c-0.094-0.037-0.164-0.104-0.216-0.188
		l-0.005,0.042c-0.261-0.241-0.431-0.601-0.431-1.002c0-0.188,0.043-0.366,0.108-0.522c0.028-0.126,0.103-0.225,0.196-0.297
		c0.01-0.016,0.014-0.036,0.025-0.052c0.038-0.062,0.089-0.115,0.15-0.152c0.042-0.026,0.084-0.047,0.127-0.067
		c0.047-0.016,0.089-0.042,0.136-0.058c0.047-0.016,0.099-0.031,0.155-0.042c0.094-0.02,0.197-0.036,0.295-0.047
		c0.047-0.005,0.099-0.005,0.146-0.005c0.005,0,0.01,0.005,0.019,0.005c0.018-0.005,0.038-0.01,0.06-0.01
		c0.117,0,0.211,0.042,0.286,0.099c0.16,0.036,0.274,0.142,0.339,0.283c0.188,0.229,0.305,0.531,0.305,0.866
		c0,0.721-0.526,1.304-1.174,1.304c-0.037,0-0.074-0.01-0.108-0.01v-0.016H285.275z M284.032,124
		c-0.184,0.292-0.287,0.647-0.287,1.028c0,0.673,0.334,1.258,0.826,1.576l-9.839,75.623l0.657,0.104l9.82-75.497
		c0.061,0.01,0.116,0.02,0.178,0.02c0.907,0,1.643-0.82,1.643-1.826c0-0.387-0.107-0.741-0.291-1.034l0.057-0.01l0.418-4.186
		c0.282-0.057,0.558-0.115,0.84-0.171c-1.29,9.317-10.914,78.727-11.604,83.566c-0.348,0.104-1.286,0.213-3.178,0.131
		c-0.037-0.006-0.066-0.022-0.089-0.052c-0.019-0.022-0.038-0.058-0.028-0.116l10.49-82.683c0.249-0.042,0.498-0.089,0.751-0.136
		L284.032,124z M332.968,72.168c0.098,2.161,0.089,4.537-0.056,5.538c-5.891-1.973-11.745-3.496-17.316-4.514l-1.14-7.715
		C321.092,67.633,327.546,70.028,332.968,72.168 M294.504,60.179c0.393,0.073,0.788,0.152,1.187,0.23
		c0.338,0.067,0.676,0.135,1.014,0.209c0.371,0.073,0.746,0.156,1.121,0.24c0.283,0.062,0.565,0.125,0.846,0.188
		c0.666,0.151,1.346,0.312,2.027,0.474c0.507,0.125,1.024,0.255,1.54,0.386c0.44,0.11,0.887,0.225,1.337,0.345
		c0.07,0.02,0.141,0.036,0.211,0.057c0.694,0.188,1.389,0.376,2.084,0.569c0.019,0.006,0.038,0.011,0.057,0.017
		c0.68,0.192,1.361,0.385,2.042,0.583c0.107,0.032,0.215,0.062,0.324,0.094c0.591,0.177,1.187,0.355,1.779,0.532
		c0.596,0.183,1.188,0.366,1.779,0.548c0.107,0.036,0.22,0.068,0.329,0.104c0.286,0.083,0.568,0.177,0.854,0.266l1.173,7.923
		c-2.488-0.417-4.914-0.74-7.252-0.949c-3.897-0.35-10.919,1.236-13.683,1.91C294.189,70.038,294.442,62.69,294.504,60.179
		 M285.261,28.162c0.348,0.95,0.728,2.182,1.131,3.602c0.076,0.271,0.155,0.554,0.236,0.84c0.075,0.271,0.149,0.548,0.225,0.83
		c0.042,0.162,0.089,0.325,0.136,0.492c0.029,0.109,0.057,0.229,0.09,0.344c0.061,0.229,0.121,0.46,0.183,0.695
		c0.127,0.49,0.258,0.997,0.385,1.509c0.108,0.412,0.216,0.834,0.319,1.258c0.056,0.219,0.108,0.444,0.163,0.667
		c0.057,0.219,0.108,0.434,0.16,0.653c0.029,0.104,0.052,0.215,0.08,0.319c0.122,0.506,0.249,1.007,0.371,1.513
		c0.01,0.047,0.025,0.094,0.033,0.141c0.104,0.439,0.211,0.877,0.315,1.316c0.005,0.022,0.009,0.036,0.014,0.058
		c0.103,0.418,0.201,0.834,0.296,1.247c0.017,0.089,0.042,0.171,0.06,0.255c0.103,0.418,0.202,0.835,0.295,1.247
		c0.038,0.157,0.077,0.313,0.114,0.464c0.093,0.402,0.182,0.799,0.276,1.185c0.991,4.218,2.019,8.576,3.047,12.611
		c-0.005,0.199-0.014,0.663-0.034,1.326c0,0.062,0,0.119-0.004,0.187c0,0.074-0.005,0.152-0.005,0.229
		c-0.004,0.052-0.004,0.11-0.009,0.168c-0.009,0.276-0.019,0.579-0.033,0.897c-0.004,0.1-0.004,0.204-0.009,0.303
		s-0.009,0.199-0.014,0.297c-0.005,0.126-0.009,0.257-0.019,0.387v0.016c-0.004,0.177-0.013,0.354-0.023,0.537
		c-0.009,0.183-0.018,0.365-0.028,0.558c-0.009,0.188-0.023,0.376-0.034,0.569c-0.008,0.193-0.022,0.387-0.033,0.585
		c-0.009,0.116-0.013,0.235-0.022,0.35c-0.009,0.183-0.025,0.365-0.038,0.548c-0.009,0.188-0.023,0.371-0.037,0.553
		c-0.015,0.188-0.03,0.371-0.043,0.56c-0.034,0.386-0.066,0.772-0.099,1.153c-0.052,0.537-0.108,1.065-0.163,1.576
		c-0.024,0.173-0.048,0.351-0.066,0.518c-0.048,0.344-0.09,0.679-0.141,0.997c-0.023,0.161-0.052,0.319-0.076,0.474
		c-0.028,0.152-0.056,0.303-0.085,0.45c-0.028,0.146-0.055,0.287-0.084,0.428c-0.029,0.135-0.056,0.271-0.09,0.402
		c-0.042,0.188-0.085,0.365-0.136,0.532c-0.047,0.168-0.094,0.319-0.145,0.464c-1.244,1.139-11.699,10.466-23.429,14.073
		l-3.971,0.944l1.825-20.325c0.034-0.872,0.7-20.299,0.517-24.355c11.332-5.892,16.547-15.048,18.008-18.044
		C284.848,27.107,285.049,27.583,285.261,28.162 M251.121,19.622c13.837,0.225,28.85,4.678,32.483,6.227
		c-1.597,3.377-9.961,18.723-31.216,22.053c-0.459,0.057-0.905,0.115-1.342,0.173c-0.436-0.058-0.883-0.116-1.328-0.168
		c-21.269-3.335-29.635-18.686-31.236-22.058C222.138,24.283,237.24,19.815,251.121,19.622 M209.009,58.963
		c0.995-3.909,1.986-8.106,2.939-12.173c1.76-7.474,4.098-17.407,5.468-20.027c1.465,3.001,6.69,12.176,18.064,18.07
		c0.136,2.37,0.911,11.494,1.286,14.422c0.361,2.834-1.521,22.857-2.592,29.341c-11.523-3.77-22.475-12.987-23.808-14.136
		c-1.225-3.481-1.446-13.921-1.47-15.053C208.934,59.26,208.972,59.11,209.009,58.963 M189.05,65.022
		c0.338-0.103,0.676-0.213,1.014-0.318c0.544-0.173,1.089-0.339,1.629-0.506c0.286-0.089,0.577-0.173,0.864-0.261
		c1.207-0.36,2.408-0.711,3.605-1.043c0.188-0.058,0.376-0.11,0.564-0.158c0.578-0.161,1.155-0.318,1.732-0.469
		c0.521-0.136,1.037-0.272,1.554-0.403c0.511-0.129,1.023-0.255,1.535-0.38c0.281-0.068,0.563-0.141,0.844-0.203
		c0.014-0.006,0.029-0.006,0.043-0.011c0.38-0.089,0.759-0.177,1.14-0.261c0.23-0.052,0.46-0.103,0.69-0.151
		c0.376-0.089,0.746-0.167,1.117-0.24c0.31-0.068,0.62-0.132,0.925-0.194c0.08-0.015,0.16-0.031,0.24-0.047
		c0.347-0.068,0.694-0.135,1.037-0.199c0.061,2.511,0.314,9.86,1.23,13.728c-2.765-0.674-9.788-2.255-13.684-1.91
		c-2.337,0.209-4.764,0.532-7.252,0.949L189.05,65.022z M169.118,72.168c0.338-0.135,0.681-0.266,1.028-0.402
		c0.07-0.026,0.141-0.051,0.211-0.083h0.005c0.455-0.178,0.916-0.355,1.38-0.537c0.098-0.043,0.201-0.079,0.305-0.12
		c0.075-0.026,0.15-0.058,0.225-0.084c0.361-0.141,0.723-0.282,1.094-0.418c1.61-0.611,3.29-1.237,5.008-1.858
		c0.583-0.215,1.169-0.423,1.761-0.631c0.45-0.162,0.901-0.319,1.357-0.481c0.802-0.281,1.619-0.563,2.436-0.84
		c0.789-0.271,1.582-0.537,2.375-0.798c0.446-0.146,0.887-0.293,1.333-0.439l-1.146,7.715c-5.567,1.018-11.424,2.542-17.311,4.514
		C169.029,76.705,169.024,74.329,169.118,72.168 M150.309,81.595c0.206-0.183,0.418-0.36,0.633-0.543
		c0.222-0.178,0.442-0.36,0.663-0.538c0.226-0.183,0.455-0.355,0.685-0.532c0.226-0.173,0.455-0.339,0.685-0.501
		c0.202-0.146,0.409-0.287,0.616-0.423c0.15-0.099,0.296-0.199,0.446-0.287c0.15-0.099,0.296-0.187,0.446-0.276
		c0.136-0.078,0.267-0.157,0.399-0.235c0.309-0.167,0.62-0.329,0.92-0.47c2.042-0.95,6.374-2.85,11.96-5.084
		c-0.116,2.975-0.018,4.558,0.146,5.418c-8.496,2.83-15.495,4.072-18.796,4.552C149.483,82.332,149.882,81.966,150.309,81.595
		 M149.309,84.137c0.056-0.009,0.113-0.015,0.175-0.026c0.131-0.02,0.266-0.036,0.407-0.062c0.762-0.115,1.667-0.261,2.7-0.454
		c0.164-0.031,0.333-0.062,0.502-0.094c1.037-0.193,2.192-0.428,3.445-0.704c0.005,0,0.009,0,0.013-0.006
		c0.184-0.036,0.372-0.083,0.565-0.125c0.257-0.058,0.521-0.116,0.783-0.178c0.381-0.089,0.77-0.182,1.169-0.281
		c0.047-0.01,0.094-0.02,0.146-0.036c0.32-0.078,0.648-0.157,0.976-0.245c0.381-0.094,0.766-0.199,1.16-0.297
		c0.215-0.058,0.432-0.116,0.648-0.178c0.215-0.057,0.436-0.119,0.656-0.182c0.498-0.136,1.005-0.283,1.517-0.434
		c0.258-0.074,0.517-0.152,0.779-0.229c0.258-0.078,0.521-0.158,0.784-0.241c0.258-0.078,0.511-0.157,0.77-0.235
		c0.812-0.255,1.644-0.527,2.484-0.814c9.14-3.107,18.218-5.126,26.249-5.841c4.305-0.386,13.069,1.816,14.28,2.129
		c0.121,0.104,0.328,0.282,0.615,0.516c0.098,0.084,0.201,0.168,0.314,0.261c0.282,0.235,0.62,0.512,1.01,0.815
		c0.154,0.125,0.32,0.25,0.488,0.386c0.018,0.016,0.042,0.036,0.065,0.052c0.146,0.115,0.296,0.23,0.451,0.35
		c0.206,0.162,0.423,0.329,0.647,0.496c0.179,0.136,0.367,0.277,0.559,0.423c0.023,0.02,0.051,0.036,0.08,0.062
		c0.178,0.129,0.356,0.261,0.544,0.402c0.132,0.093,0.263,0.193,0.399,0.292c0.112,0.084,0.226,0.162,0.342,0.245
		c0.395,0.287,0.809,0.58,1.239,0.882c0.211,0.146,0.433,0.297,0.653,0.45c0.573,0.396,1.169,0.798,1.787,1.2
		c0.254,0.168,0.512,0.335,0.775,0.502c0.616,0.396,1.249,0.793,1.902,1.185c0.582,0.35,1.183,0.704,1.789,1.049
		c0.361,0.209,0.727,0.412,1.093,0.611c0.338,0.188,0.676,0.37,1.019,0.548c0.601,0.318,1.211,0.627,1.825,0.929
		c0.334,0.162,0.672,0.325,1.015,0.486c0.338,0.157,0.681,0.313,1.024,0.464c0.342,0.152,0.689,0.303,1.037,0.45
		c0.694,0.292,1.388,0.563,2.093,0.824h0.005c0.24,0.094,0.484,0.178,0.728,0.267c0.3,0.104,0.605,0.209,0.911,0.308
		c-1.01,6.384-2.193,26.72-2.244,27.591c-0.104,1.137-0.202,2.286-0.3,3.435c-3.216-0.465-19.166-2.84-27.424-5.419
		c-8.791-2.745-48.406-8.826-53.959-9.671c-0.004-0.104-0.014-0.215-0.018-0.319c-0.432-11.107-1.638-18.911-2.056-21.348
		C148.272,84.283,148.737,84.221,149.309,84.137 M30.834,258.557c0.065-0.125,0.136-0.245,0.202-0.37
		c0.023-0.047,0.051-0.089,0.076-0.136c0.009-0.02,0.022-0.035,0.033-0.057c0.084-0.146,0.163-0.299,0.248-0.449
		c0.081-0.151,0.164-0.302,0.254-0.448c0.004-0.016,0.014-0.031,0.022-0.048c0.005-0.005,0.005-0.01,0.01-0.016
		c0.127-0.218,0.248-0.437,0.376-0.657c0.206-0.366,0.418-0.724,0.624-1.081c0.761-1.31,1.478-2.547,2.122-3.773
		c0.235-0.45,0.464-0.892,0.699-1.331c0.38-0.731,0.765-1.456,1.145-2.166c0.202-0.381,0.403-0.757,0.605-1.133
		c0.197-0.376,0.399-0.747,0.601-1.117c0.361-0.673,0.723-1.336,1.084-1.994c0.235-0.422,0.47-0.846,0.699-1.263
		c2.45,1.649,13.421,9.011,24.987,16.108c-2.089,4.192-5.718,10.247-9.384,16.091c-11.45-6.577-22.87-13.727-24.987-15.063
		C30.44,259.288,30.637,258.922,30.834,258.557 M28.196,264.627c0.352-1.232,0.845-2.458,1.413-3.676
		c2.276,1.436,13.495,8.473,24.855,14.997c-4.67,7.402-9.224,14.229-10.52,16.165c-0.267-0.162-0.53-0.325-0.797-0.49
		c-9.257-5.663-18.575-11.243-21.594-13.049C25.013,271.658,27.876,265.76,28.196,264.627 M20.905,279.864
		c0.93,0.553,1.883,1.127,2.85,1.706c0.286,0.168,0.573,0.339,0.859,0.512c0.69,0.418,1.394,0.835,2.099,1.263
		c0.488,0.293,0.981,0.585,1.478,0.887c0.033,0.022,0.07,0.042,0.103,0.064c1.024,0.615,2.061,1.237,3.103,1.867l-4.131,7.653
		l-10.195-6.374C18.352,284.928,19.658,282.348,20.905,279.864 M11.019,299.151h0.005c0.061-0.116,0.122-0.235,0.188-0.356
		c0.103-0.193,0.206-0.395,0.31-0.599c0.013-0.022,0.028-0.042,0.038-0.068c0.102-0.198,0.21-0.402,0.318-0.611
		c0.014-0.026,0.033-0.057,0.047-0.089c0.103-0.199,0.211-0.406,0.32-0.616c0.018-0.036,0.038-0.067,0.056-0.104
		c0.061-0.119,0.127-0.244,0.192-0.37c0.128-0.246,0.259-0.501,0.395-0.757c0.896-1.732,1.872-3.632,2.887-5.611
		c0.211-0.412,0.427-0.825,0.638-1.243l10.172,6.359l-6.304,11.681l-10.041-6.129C10.484,300.173,10.748,299.677,11.019,299.151
		 M15.4,312.705c-0.202-0.141-0.404-0.276-0.601-0.406c-0.014-0.01-0.033-0.022-0.047-0.032c-0.206-0.141-0.408-0.277-0.61-0.412
		c-0.107-0.073-0.215-0.146-0.319-0.213c-0.184-0.126-0.366-0.246-0.54-0.367c-0.399-0.277-0.78-0.537-1.136-0.782
		c-0.169-0.116-0.338-0.235-0.497-0.345c-0.278-0.193-0.535-0.376-0.78-0.547c-0.08-0.058-0.159-0.11-0.235-0.168
		c-0.103-0.073-0.201-0.141-0.3-0.213c-0.121-0.084-0.235-0.168-0.347-0.246c-0.065-0.047-0.132-0.093-0.193-0.141
		c-0.112-0.089-0.215-0.161-0.314-0.235c-0.159-0.119-0.3-0.224-0.423-0.318c-0.004-0.005-0.009-0.005-0.013-0.01
		c-0.005,0-0.005-0.006-0.009-0.006c-0.029-0.02-0.057-0.042-0.085-0.067c-0.029-0.022-0.057-0.043-0.085-0.068
		c-0.197-0.158-0.334-0.271-0.399-0.345c-0.193-0.219-0.333-0.627-0.399-1.185c-0.121-1.053,0.108-2.166,0.648-3.131
		c0.226-0.408,0.511-0.93,0.845-1.556l10.036,6.123l-2.962,5.491C16.211,313.243,15.799,312.972,15.4,312.705 M64.256,308.916
		c-0.267,0.548-0.553,1.123-0.849,1.712c-0.117,0.241-0.24,0.48-0.366,0.727c-0.206,0.412-0.418,0.824-0.643,1.252
		c-0.08,0.157-0.164,0.319-0.248,0.48c-0.211,0.412-0.433,0.831-0.657,1.253c-0.169,0.318-0.343,0.641-0.517,0.965
		c-0.085,0.162-0.174,0.324-0.262,0.486c-0.263,0.486-0.531,0.971-0.807,1.456c-0.179,0.324-0.361,0.647-0.545,0.972
		c-0.094,0.161-0.188,0.324-0.282,0.485c-0.121,0.215-0.244,0.422-0.365,0.631c-0.404,0.695-0.813,1.378-1.226,2.047
		c-0.127,0.208-0.253,0.418-0.385,0.627c-0.108,0.171-0.215,0.344-0.328,0.516c-0.142,0.219-0.283,0.438-0.419,0.653
		c-0.352,0.541-0.708,1.069-1.061,1.581c-0.141,0.203-0.282,0.402-0.423,0.6c-0.018,0.026-0.038,0.052-0.056,0.078
		c-0.188,0.266-0.376,0.522-0.564,0.773c-0.385,0.516-0.766,0.997-1.14,1.445c-0.08,0.099-0.159,0.193-0.245,0.287
		c-0.324,0.381-0.647,0.736-0.967,1.055c-0.07,0.073-0.14,0.146-0.215,0.213c-0.047,0.047-0.094,0.094-0.141,0.135
		c-0.085,0.085-0.168,0.162-0.253,0.235c-0.085,0.079-0.169,0.152-0.254,0.22c-0.075,0.067-0.145,0.125-0.221,0.177
		c-0.06,0.052-0.117,0.1-0.179,0.141c-0.065,0.052-0.131,0.1-0.201,0.146c-0.066,0.048-0.132,0.094-0.197,0.136
		c-0.137,0.089-0.273,0.167-0.404,0.235c-0.056,0.031-0.112,0.057-0.164,0.083c-0.07,0.037-0.141,0.062-0.206,0.089
		c-0.07,0.032-0.136,0.052-0.202,0.074c-0.052,0.016-0.098,0.031-0.145,0.042c-0.057,0.016-0.108,0.031-0.16,0.035
		c-0.069,0.017-0.141,0.027-0.206,0.033c-0.066,0.003-0.132,0.003-0.202,0.003c-0.051,0-0.103,0-0.155-0.003
		c-0.051,0-0.102-0.006-0.159-0.011c-0.051-0.005-0.108-0.01-0.168-0.022c-0.061-0.005-0.128-0.015-0.188-0.025
		c-0.169-0.027-0.343-0.068-0.531-0.11c-0.089-0.02-0.179-0.047-0.273-0.073c-0.07-0.016-0.145-0.037-0.226-0.062
		c-0.149-0.048-0.304-0.094-0.469-0.146c-0.16-0.052-0.329-0.11-0.502-0.173c-0.038-0.016-0.076-0.026-0.117-0.041
		c-0.117-0.048-0.24-0.09-0.361-0.137c-0.849-0.328-1.807-0.751-2.849-1.241c-0.193-0.094-0.39-0.188-0.592-0.287
		c-0.455-0.22-0.925-0.455-1.404-0.699c-0.6-0.309-1.22-0.632-1.859-0.977c-0.253-0.135-0.511-0.276-0.775-0.418
		c-0.033-0.016-0.06-0.031-0.093-0.052c-0.226-0.119-0.46-0.245-0.69-0.376c-0.263-0.145-0.531-0.292-0.798-0.443
		c-0.399-0.225-0.807-0.454-1.216-0.689c-0.31-0.173-0.62-0.351-0.929-0.533c-0.193-0.109-0.385-0.224-0.583-0.334
		c-0.004-0.005-0.009-0.005-0.013-0.01c-0.325-0.187-0.648-0.376-0.972-0.569c-0.423-0.245-0.845-0.496-1.268-0.751
		c-0.282-0.167-0.568-0.339-0.854-0.507c-0.141-0.089-0.282-0.171-0.423-0.254c-0.21-0.132-0.427-0.257-0.643-0.387
		c-0.211-0.129-0.422-0.261-0.638-0.392c-0.286-0.171-0.568-0.345-0.854-0.522c-0.141-0.083-0.286-0.171-0.427-0.26
		c-0.282-0.174-0.564-0.351-0.85-0.528c-0.136-0.083-0.277-0.173-0.422-0.261c-0.283-0.173-0.564-0.35-0.845-0.528
		c-0.423-0.26-0.841-0.526-1.263-0.788c-0.273-0.177-0.549-0.348-0.822-0.527c-1.145-0.725-2.262-1.44-3.342-2.14
		c-0.168-0.115-0.343-0.225-0.511-0.334c-0.578-0.376-1.136-0.742-1.685-1.102l14.787-27.409c0.464,0.282,0.929,0.563,1.394,0.841
		c0.464,0.282,0.929,0.564,1.393,0.846c1.037,0.631,2.075,1.262,3.107,1.889c0.352,0.213,0.709,0.434,1.062,0.647
		c0.92,0.558,1.83,1.117,2.736,1.671c0.372,0.229,0.742,0.454,1.113,0.678c0.493,0.303,0.981,0.606,1.47,0.904
		c0.356,0.22,0.713,0.438,1.065,0.653c2.343,1.446,4.587,2.834,6.666,4.128c0.381,0.241,0.761,0.474,1.131,0.709
		c0.372,0.235,0.737,0.464,1.099,0.69c0.098,0.061,0.196,0.125,0.295,0.187c0.23,0.141,0.455,0.287,0.676,0.428
		c0.029,0.016,0.056,0.036,0.085,0.053c0.412,0.26,0.817,0.516,1.211,0.766c0.206,0.135,0.413,0.267,0.62,0.397
		c0.094,0.062,0.193,0.125,0.286,0.182c0.108,0.069,0.211,0.136,0.315,0.204c0.249,0.161,0.492,0.318,0.732,0.47
		c0.324,0.213,0.638,0.417,0.944,0.611c0.178,0.113,0.346,0.229,0.515,0.339c0.169,0.109,0.334,0.213,0.493,0.324
		c0.168,0.11,0.334,0.218,0.493,0.324c0.145,0.093,0.286,0.187,0.422,0.281c0.146,0.094,0.287,0.193,0.423,0.282
		c0.253,0.173,0.493,0.335,0.714,0.486c0.184,0.131,0.357,0.251,0.517,0.365c0.122,0.083,0.24,0.167,0.347,0.245
		c0.108,0.078,0.207,0.157,0.306,0.225c0.065,0.047,0.127,0.093,0.183,0.135c0.06,0.047,0.117,0.089,0.168,0.132
		c0.057,0.041,0.113,0.083,0.16,0.119c0.127,0.104,0.225,0.187,0.304,0.261C64.778,307.841,64.523,308.368,64.256,308.916
		 M71.251,297.026c-1.141,1.79-2.277,3.576-3.418,5.351c-0.615,0.953-1.225,1.909-1.841,2.87l-0.051,0.1
		c-0.099,0.219-0.207,0.448-0.314,0.694c-1.492-1.243-6.07-4.353-20.509-13.206c1.474-2.196,5.957-8.92,10.547-16.196
		c8.661,4.942,17.214,9.453,21.744,10.82C75.311,290.643,73.264,293.858,71.251,297.026 M88.056,272.587
		c-0.432,0.538-0.86,1.082-1.282,1.629c-0.427,0.548-0.849,1.097-1.267,1.655c-0.381,0.506-0.761,1.017-1.136,1.53
		c-0.089,0.119-0.174,0.24-0.262,0.36c-0.315,0.422-0.62,0.85-0.93,1.278c-0.704,0.986-1.404,1.979-2.098,2.981
		c-0.141,0.199-0.278,0.402-0.413,0.599c-0.141,0.204-0.278,0.409-0.413,0.606c-0.385,0.558-0.765,1.123-1.144,1.686
		c-0.283,0.418-0.565,0.84-0.846,1.263c-4.163-1.081-12.903-5.685-21.822-10.773c3.637-5.804,7.234-11.817,9.346-16.061
		c8.497,5.183,17.166,10.116,22.908,12.465C88.482,272.064,88.267,272.327,88.056,272.587 M142.799,207.091
		c-2.211,2.901-4.31,5.946-6.342,8.883c-2.952,4.275-6.004,8.692-9.416,12.726c-5.553,6.551-11.486,12.976-17.223,19.193
		c-6.765,7.324-13.735,14.881-20.157,22.726c-5.661-2.224-14.538-7.27-23.245-12.585c-0.042-0.019-0.085-0.052-0.117-0.083
		c-0.103-0.068-0.21-0.12-0.319-0.177c-0.113-0.058-0.226-0.12-0.329-0.193c-0.085-0.058-0.169-0.126-0.249-0.193
		c0,0-0.005-0.006-0.009-0.006c-0.052-0.011-0.099-0.036-0.146-0.064v0.006c-11.514-7.072-22.456-14.411-24.911-16.071
		c1.713-3.064,3.394-5.95,5.055-8.696c2.587-4.265,5.272-8.857,7.868-13.3c3.342-5.715,6.793-11.618,10.178-17.084
		c1.929-3.116,3.924-6.581,6.097-10.601c1.258-2.328,2.511-4.714,3.722-7.021c0.62-1.169,1.235-2.343,1.855-3.518
		c3.919-7.401,7.67-13.801,11.463-19.552c0.535-0.809,1.084-1.613,1.638-2.406c2.431,3.413,12.843,17.851,17.832,21.959
		c0,0,0,0.006-0.004,0.006c0.009,0.005,0.009,0.01,0.018,0.015c0.014,0.01,0.034,0.022,0.047,0.036
		c0.034,0.043,0.066,0.084,0.099,0.132c0.061,0.041,0.117,0.089,0.174,0.135c0.023,0.02,0.043,0.042,0.065,0.062
		c0.01,0.01,0.023,0.022,0.034,0.032c0.056,0.047,0.116,0.094,0.168,0.151c0.043,0.042,0.085,0.094,0.127,0.136
		c0.043,0.047,0.09,0.083,0.132,0.125c0.019,0.022,0.042,0.042,0.061,0.062c0.005,0.006,0.005,0.006,0.009,0.011
		c0.029,0.02,0.047,0.051,0.07,0.083c0-0.006,0.005-0.006,0.005-0.01c1.755,1.999,5.05,4.854,7.745,7.009
		c2.732,2.183,4.394,3.357,5.436,3.963c0.131,0.02,0.262,0.047,0.394,0.089c0.169,0.052,0.338,0.129,0.507,0.183
		c0.351,0.109,0.676,0.245,0.971,0.48l0.005-0.006c0.464,0.261,1.272,0.804,2.07,1.336c4.041,2.715,12.124,8.138,20.753,9.448
		C144.192,205.348,143.475,206.204,142.799,207.091 M154.441,195.336c-2.812,2.49-5.68,5.042-8.31,7.846
		c-8.726-0.966-17.147-6.613-21.264-9.379c-0.742-0.502-1.301-0.872-1.736-1.144c-0.099-0.047-0.198-0.093-0.296-0.146
		c-0.103-0.051-0.202-0.109-0.305-0.167c-0.01-0.005-0.052-0.031-0.094-0.051c-0.052-0.022-0.215-0.09-0.215-0.09
		c-0.01-0.005-0.01-0.005-0.014-0.005c-0.025-0.006-0.043-0.006-0.057-0.011c-0.15-0.015-0.291-0.052-0.422-0.109l-0.019,0.02
		c-0.018,0.006-0.038,0.006-0.051,0.01c-1.409-0.485-10.628-7.558-13.782-11.28l0.009-0.01c-0.437-0.225-0.765-0.579-0.99-1.002
		l-0.033,0.048c-4.896-3.988-15.885-19.297-17.805-21.996c2.531-3.549,5.221-6.957,7.839-10.282
		c1.221-1.551,2.442-3.106,3.653-4.672c0.371-0.474,0.737-0.955,1.104-1.43c2.412,5.711,13.321,20.414,15.429,23.234l-0.028,0.041
		c0.267,0.209,0.511,0.47,0.708,0.799c0.065,0.11,0.132,0.219,0.197,0.328l0.009-0.015c1.877,2.37,8.211,10.012,13.914,12.929
		c0.098,0.026,0.197,0.052,0.3,0.093c0.065,0.027,0.132,0.064,0.197,0.09c0.014,0.005,0.029,0.005,0.043,0.01
		c0.178,0.052,0.342,0.141,0.502,0.241c0.009,0.005,0.018,0.009,0.028,0.015c0.075,0.037,0.15,0.074,0.216,0.12
		c0.018,0.016,0.037,0.032,0.056,0.047c3.051,1.331,8.323,3.91,13.34,6.416c5.013,2.505,9.773,4.938,11.801,5.976
		C157.064,193.008,155.74,194.183,154.441,195.336 M159.491,190.754c-2.844-1.461-18.19-9.317-25.071-12.397
		c-0.648-0.152-1.212-0.506-1.826-0.82c-0.005-0.005-0.01-0.01-0.014-0.01c-5.629-2.803-12.238-10.894-13.797-12.867l0.01-0.016
		c-0.31-0.24-0.507-0.601-0.723-0.939c-0.034-0.048-0.07-0.094-0.113-0.136c-0.023-0.022-0.037-0.048-0.056-0.074
		c-4.375-5.845-14.05-19.281-15.289-23.259c0.695-0.902,1.389-1.806,2.085-2.708l4.468-5.815c1.559-2.025,3.118-4.05,4.675-6.075
		c1.587-2.067,3.178-4.128,4.769-6.191c1.582-2.051,3.169-4.098,4.755-6.143c1.545-1.983,3.085-3.962,4.634-5.94
		c1.46-1.863,2.924-3.722,4.394-5.575c1.342-1.691,2.69-3.377,4.047-5.052c1.323-1.639,2.493-3.069,3.581-4.375
		c1.165-1.398,2.122-2.52,3.015-3.532c0.718-0.821,1.492-1.692,2.313-2.527l0.09-0.09c0.403-0.417,0.821-0.84,1.258-1.158
		c0.464,2.808,1.549,10.272,1.958,20.681c0.004,0.213,0.023,0.438,0.033,0.652c-0.014,0.037-0.029,0.078-0.043,0.115
		c0.01,0.048,0.014,0.1,0.014,0.157c0.005,0.45,0.014,0.904,0.042,1.352c0.034,0.439,0.062,0.685,0.142,1.123
		c0.028,0.135,0.047,0.271,0.065,0.408c0.014-0.026,0.023-0.052,0.033-0.074c0.817,7.663,3.102,17.194,5.159,25.754
		c0.08,0.339,0.164,0.679,0.244,1.018c0,0.02-0.005,0.036-0.009,0.058c0.098,0.141,0.154,0.312,0.168,0.49
		c0,0,0.009,0.089,0.009,0.125c0.005,0.032,0.01,0.078,0.014,0.084c0.014,0.099,0.038,0.203,0.061,0.302
		c0.047,0.215,0.108,0.423,0.174,0.637c0.117,0.393,0.244,0.783,0.32,1.196c0.028,0.151,0.047,0.312,0.065,0.479
		c1.169,4.949,2.15,9.401,2.473,12.424c0.986,9.191,3.549,33.447,3.897,36.74C160.857,189.444,160.176,190.101,159.491,190.754
		 M159.303,221.895c0.08-0.679,0.159-1.368,0.244-2.073c0.085-0.705,0.169-1.425,0.249-2.15c0.047-0.392,0.09-0.793,0.136-1.191
		c0.019-0.135,0.034-0.266,0.047-0.402c0.034-0.266,0.061-0.532,0.09-0.804c0.047-0.402,0.093-0.809,0.136-1.217
		c0.047-0.406,0.094-0.814,0.136-1.22c0.047-0.408,0.095-0.815,0.137-1.221c0.089-0.793,0.178-1.593,0.267-2.38
		c0.122-1.112,0.244-2.219,0.361-3.304c0.056-0.522,0.108-1.033,0.164-1.545c5.877,0.595,50.209,5.068,64.441,5.908
		c-0.249,5.799-0.46,11.609-0.605,17.539c-0.034,1.439-0.076,2.891-0.118,4.348c-0.225-0.005-0.361-0.01-0.38-0.01
		c-17.504,0.339-59.817-7.746-65.478-8.843C159.186,222.859,159.243,222.385,159.303,221.895 M152.441,287.536
		c1.117-18.132,2.266-36.882,5.422-54.878c0.281-1.624,0.661-4.433,1.088-7.862c5.859,1.133,48.063,9.182,65.652,8.858
		c0.052,0,0.174,0.005,0.343,0.01c-0.145,4.859-0.32,9.761-0.492,14.552c-0.301,8.247-0.606,16.776-0.756,25.033
		c-0.253,14.324-0.549,29.576-0.981,45.333c-48.782-5.621-68.281-19.626-70.867-21.646
		C152.056,293.784,152.248,290.626,152.441,287.536 M151.06,317.898c0.038-1.622,0.076-3.324,0.113-4.983
		c0.014-0.596,0.029-1.185,0.042-1.765c0.005-0.213,0.01-0.422,0.018-0.636c0.005-0.216,0.01-0.429,0.015-0.644
		c0.008-0.354,0.018-0.704,0.028-1.043c0.009-0.428,0.018-0.846,0.033-1.247c0.009-0.408,0.023-0.793,0.033-1.169
		c0.014-0.528,0.029-1.023,0.047-1.482c0.029-0.918,0.056-1.687,0.085-2.244c0.005-0.094,0.01-0.183,0.014-0.261
		c0-0.022,0-0.047,0.004-0.068c0.005-0.136,0.014-0.251,0.019-0.351c0.08-1.111,0.155-2.227,0.226-3.345
		c4.492,3.342,24.217,16.035,70.938,21.406c-0.085,3.011-0.175,6.039-0.267,9.083c-0.132,4.075-0.273,8.179-0.423,12.275
		c-46.463-6.013-68.215-20.481-70.943-22.417C151.05,318.641,151.056,318.274,151.06,317.898 M221.35,357.954
		c-0.132,3.419-0.183,6.969-0.231,10.403c-0.009,0.625-0.018,1.258-0.028,1.89c0,0.103-0.004,0.208-0.004,0.312
		c-0.01,0.736-0.024,1.472-0.038,2.214c-0.01,0.474-0.019,0.955-0.029,1.43c-0.009,0.528-0.023,1.049-0.038,1.571v0.02
		c-0.009,0.476-0.023,0.95-0.042,1.426c-0.023,0.74-0.047,1.482-0.08,2.218c-0.029,0.737-0.066,1.472-0.108,2.203
		c-0.009,0.25-0.023,0.495-0.043,0.741c-0.009,0.171-0.018,0.344-0.028,0.516c-0.014,0.224-0.029,0.45-0.042,0.673
		c-0.014,0.167-0.023,0.329-0.038,0.49c-0.043,0.653-0.094,1.294-0.15,1.938c-25.635-1.687-65.277-10.664-67.384-12.675
		c-1.742-1.706-2.131-3.131-2.724-5.298c-0.121-0.444-0.253-0.913-0.398-1.419c-0.009-0.032-0.018-0.068-0.029-0.11
		c-0.014-0.064-0.029-0.135-0.038-0.215c-0.013-0.078-0.023-0.171-0.033-0.266c-0.028-0.266-0.047-0.59-0.065-0.971
		c-0.009-0.095-0.014-0.193-0.014-0.297c-0.005-0.1-0.009-0.21-0.009-0.319c-0.01-0.188-0.01-0.386-0.014-0.595
		c-0.005-0.152-0.005-0.308-0.009-0.47c-0.005-0.669-0.005-1.414,0-2.229c0-0.177,0-0.36,0.004-0.547
		c0-0.387,0.009-0.784,0.014-1.196c0.005-0.354,0.009-0.715,0.019-1.091c0.004-0.235,0.009-0.469,0.013-0.709
		c0.01-0.6,0.023-1.216,0.042-1.848c0.01-0.345,0.019-0.689,0.029-1.044c0-0.077,0.005-0.156,0.01-0.235
		c0.028-1.116,0.065-2.27,0.098-3.439c0.005-0.068,0.005-0.135,0.009-0.203c0.009-0.402,0.023-0.809,0.038-1.216
		c0.028-0.736,0.056-1.478,0.08-2.213c0.023-0.611,0.047-1.217,0.071-1.816c0.018-0.486,0.037-0.966,0.055-1.446
		c0.005-0.115,0.01-0.235,0.014-0.35c0.01-0.299,0.023-0.589,0.033-0.882c0.009-0.204,0.014-0.403,0.024-0.602
		c0.018-0.385,0.033-0.766,0.046-1.136c0.019-0.413,0.034-0.825,0.052-1.228c0.029-0.704,0.056-1.387,0.085-2.05
		c0.009-0.241,0.018-0.476,0.028-0.709c0.009-0.174,0.014-0.345,0.025-0.518c0.013-0.344,0.028-0.679,0.042-1.002
		c0.183-4.337,0.329-7.766,0.343-9.056c0.009-1.19,0.046-3.335,0.098-5.876c4.802,3.21,26.874,16.488,70.919,22.178
		c-0.174,4.682-0.351,9.343-0.535,13.92L221.35,357.954z M250.956,387.357h-2.168c-4.609-0.1-8.726-0.318-14.424-0.627
		c-3.192-0.173-6.859-0.366-11.356-0.586c-0.404-0.015-0.812-0.036-1.225-0.061c0.498-5.789,0.587-11.838,0.667-17.7
		c0.047-3.425,0.098-6.969,0.23-10.367l0.047-1.132c0.179-4.547,0.357-9.172,0.531-13.812c0.976,0.121,1.957,0.241,2.957,0.356
		c0.869,0.041,18.866,0.892,25.296,0.892c0.464,0,0.869-0.006,1.202-0.016L250.956,387.357z M351.18,326.6
		c0.01,1.289,0.155,4.719,0.338,9.056c0.015,0.329,0.03,0.669,0.043,1.017c0.033,0.696,0.061,1.426,0.094,2.183
		c0.014,0.376,0.033,0.762,0.047,1.153c0.005,0.106,0.009,0.213,0.014,0.319c0.009,0.276,0.023,0.557,0.033,0.845
		c0.028,0.606,0.052,1.227,0.076,1.854c0.014,0.37,0.028,0.741,0.047,1.112c0.009,0.287,0.017,0.583,0.033,0.876
		c0.014,0.386,0.028,0.779,0.042,1.164c0.009,0.178,0.014,0.35,0.019,0.522c0.022,0.544,0.042,1.085,0.06,1.629
		c0.038,1.143,0.075,2.282,0.113,3.403c0.013,0.37,0.028,0.741,0.038,1.112c0.022,0.73,0.047,1.451,0.06,2.156
		c0.009,0.339,0.019,0.679,0.029,1.007c0.009,0.335,0.018,0.664,0.023,0.986c0.004,0.161,0.004,0.319,0.009,0.481
		c0.014,0.678,0.028,1.335,0.038,1.961c0.004,0.251,0.004,0.492,0.009,0.731c0,0.177,0.005,0.354,0.005,0.528
		c0.005,0.171,0.005,0.344,0.005,0.511c0.017,2.803-0.039,4.813-0.212,5.403c-0.15,0.506-0.277,0.975-0.399,1.419
		c-0.591,2.167-0.981,3.591-2.727,5.298c-2.178,2.078-44.472,11.603-69.933,12.819c-2.39,0.116-4.713,0.232-6.952,0.339
		c-7.759,0.381-14.496,0.711-19.847,0.857l0.629-15.388l1.136-27.737c1.057-0.064,3.019-0.121,5.552-0.194
		c7.915-0.235,22.64-0.663,36.178-2.166c17.452-1.941,48.626-15.32,55.334-19.313C351.148,324.231,351.166,325.655,351.18,326.6
		 M350.575,302.004c0.132,1.864,0.372,11.861,0.507,18.866c-4.525,3.183-37.361,17.506-55.432,19.515
		c-13.491,1.498-28.184,1.926-36.079,2.156c-2.516,0.074-4.365,0.132-5.46,0.193l0.025-0.599v-20.743
		c0.788,0.078,1.812,0.115,2.994,0.115c7.502,0,21.335-1.342,22.049-1.414c46.928-5.355,66.709-18.106,71.186-21.442
		C350.43,299.772,350.5,300.893,350.575,302.004 M343.487,226.19c2.022,16.583,4.112,33.729,5.557,50.673
		c0.419,4.858,0.672,9.822,0.926,14.62c0.093,1.79,0.187,3.612,0.291,5.438c-2.507,1.963-22.063,16.093-71.21,21.698
		c-0.197,0.022-19.444,1.884-24.917,1.289v-1.754c0-6.118,1.295-53.996,2.126-84.088c1.995-0.183,4.042-0.204,6.036-0.219
		c0.835-0.005,1.667-0.01,2.497-0.032c2.07-0.042,4.142-0.073,6.216-0.11c5.501-0.083,11.19-0.171,16.786-0.489
		c1.221-0.074,2.459-0.204,3.657-0.335l0.953-0.099c5.182-0.538,10.749-1.258,17.524-2.27c5.318-0.789,10.833-1.681,16.856-2.724
		c4.216-0.732,8.426-1.494,12.519-2.261c1.338-0.25,2.673-0.506,4.01-0.766C343.37,225.235,343.43,225.714,343.487,226.19
		 M340.877,204.382c0.061,0.522,0.122,1.049,0.183,1.571c0.155,1.321,0.31,2.641,0.466,3.963c0.309,2.636,0.624,5.271,0.943,7.887
		c0.155,1.278,0.31,2.557,0.464,3.831c0.005,0.026,0.005,0.058,0.01,0.083c0.065,0.528,0.127,1.05,0.192,1.577
		c-1.352,0.267-2.704,0.522-4.056,0.778c-4.083,0.767-8.289,1.524-12.5,2.255c-6.014,1.039-11.52,1.931-16.83,2.724
		c-6.754,1.002-12.307,1.723-17.466,2.26l-0.958,0.099c-1.183,0.125-2.408,0.262-3.595,0.329c-5.577,0.313-11.253,0.403-16.74,0.492
		c-2.074,0.031-4.15,0.061-6.224,0.109c-0.822,0.016-1.649,0.02-2.479,0.026c-1.967,0.016-3.989,0.042-5.985,0.213
		c0.287-10.36,0.517-18.404,0.605-21.535c4.323-0.229,19.89-0.49,20.081-0.49C290.706,209.79,335.267,204.993,340.877,204.382
		 M340.573,188.775c0.351-3.325,2.934-27.773,3.896-36.74c0.324-3.017,1.305-7.47,2.469-12.408c0.022,0.126,0.056,0.245,0.084,0.365
		c0.061-1.174,0.315-2.296,0.741-3.601c-0.003-0.052-0.013-0.1-0.017-0.152c0.084-0.339,0.163-0.679,0.248-1.018
		c2.057-8.56,4.338-18.09,5.159-25.754c0.028,0.074,0.065,0.157,0.098,0.229c-0.033-0.834-0.004-1.706,0.039-2.677
		c0.013-0.245,0.055-0.46,0.112-0.669c0.014-0.203,0.028-0.412,0.037-0.615c0.404-10.419,1.493-17.888,1.953-20.691
		c0.399,0.276,0.78,0.667,1.15,1.049l0.196,0.203c1.785,1.816,3.47,3.837,5.099,5.789l0.038,0.041
		c2.643,3.169,5.187,6.348,7.327,9.036c2.54,3.2,5.305,6.718,8.689,11.076c2.708,3.476,5.557,7.161,9.243,11.948
		c2.154,2.797,4.305,5.601,6.459,8.398l2.516,3.273c1.131,1.478,2.239,2.971,3.333,4.479c-1.337,4.014-10.515,16.802-14.965,22.778
		c-0.159,0.376-0.398,0.715-0.624,1.023c-0.146,0.199-0.31,0.371-0.479,0.538c-0.095,0.099-0.192,0.188-0.296,0.266
		c-1.953,2.448-8.59,10.398-14.088,12.83l-0.004-0.006c-0.164,0.146-0.352,0.257-0.553,0.329c-0.01,0.006-0.014,0.006-0.025,0.01
		c-0.281,0.183-0.582,0.287-0.896,0.319c-6.98,3.142-22.166,10.914-24.936,12.339C341.905,190.107,341.234,189.448,340.573,188.775
		 M346.891,194.867c-1.062-0.998-2.142-2.005-3.216-3.039c3.896-1.993,18.391-9.395,24.757-12.218
		c0.022-0.016,0.046-0.042,0.069-0.058c0.128-0.084,0.258-0.151,0.39-0.209c0.399-0.215,0.813-0.396,1.23-0.522
		c0.023-0.005,0.042-0.005,0.06-0.01c5.709-2.902,12.06-10.565,13.943-12.945l0.023,0.037c0.042-0.074,0.08-0.142,0.127-0.21
		c0.23-0.354,0.427-0.621,0.69-0.866c0.022-0.026,0.042-0.052,0.06-0.078l-0.018-0.031c2.09-2.788,12.829-17.267,15.365-23.082
		c4.004,5.611,7.763,11.441,11.373,17.35c-1.906,2.776-11.711,16.937-16.495,20.857c0,0,0,0.006-0.005,0.006
		c-0.249,0.277-0.53,0.506-0.813,0.737c-0.084,0.067-0.174,0.119-0.262,0.171l0.047,0.073c-2.905,3.425-10.941,9.684-13.304,11.04
		c-0.004-0.005-0.004-0.005-0.009-0.01c-0.159,0.104-0.324,0.193-0.502,0.255c-0.455,0.167-0.887,0.413-1.357,0.543
		c-0.038,0.011-0.08,0.011-0.121,0.022c-0.433,0.271-0.977,0.637-1.7,1.123c-4.215,2.829-12.927,8.669-21.865,9.436
		C352.631,200.254,349.73,197.524,346.891,194.867 M399.423,255.712c-2.249-2.484-4.573-5.052-6.807-7.594l-18.12-20.655
		c-3.74-4.265-7.13-8.805-10.406-13.19c-1.718-2.302-3.492-4.682-5.323-7.025c-0.709-0.914-1.447-1.79-2.198-2.652
		c8.849-1.149,17.209-6.754,21.341-9.532c0.962-0.641,1.957-1.31,2.318-1.467c0.094,0.016,0.215,0.01,0.38-0.031
		c0.014,0.015,0.029,0.026,0.043,0.041c0.056-0.047,0.117-0.089,0.178-0.12c0.46-0.24,0.902-0.516,1.376-0.709
		c1.057-0.663,2.643-1.8,5.093-3.758c2.69-2.156,5.985-5.01,7.741-7.009c0.022,0.031,0.047,0.068,0.069,0.099
		c0.099-0.109,0.207-0.209,0.315-0.297c0.183-0.293,0.408-0.537,0.657-0.721c-0.009-0.02-0.025-0.041-0.039-0.057
		c4.821-3.972,14.032-17.178,16.486-20.753c3.559,5.872,6.975,11.802,10.346,17.648c2.54,4.411,5.167,8.973,7.811,13.43
		c7.445,12.553,15.124,25.191,22.831,37.556c1.606,2.572,3.268,5.172,4.873,7.682c1.019,1.598,2.056,3.215,3.088,4.844
		c-2.886,1.948-13.289,8.9-24.292,15.67c-0.07,0.057-0.141,0.103-0.226,0.135c-0.047,0.026-0.098,0.042-0.15,0.062
		c-0.004,0-0.009,0-0.014,0.006c-0.009,0-0.018,0.005-0.022,0.005c-0.057,0.036-0.113,0.069-0.164,0.104
		c-0.061,0.042-0.127,0.084-0.189,0.131c-0.084,0.068-0.168,0.141-0.257,0.21c-0.043,0.031-0.09,0.062-0.132,0.083
		c-0.076,0.042-0.155,0.083-0.235,0.115c-8.759,5.351-17.701,10.44-23.39,12.668C408.229,265.463,403.779,260.529,399.423,255.712
		 M423.588,286.074c-1.85-2.74-3.732-5.475-5.647-8.179c-0.295-0.418-0.596-0.834-0.901-1.246c-0.113-0.152-0.221-0.304-0.333-0.455
		c-0.267-0.37-0.54-0.736-0.813-1.102l-0.009-0.009c-0.249-0.329-0.497-0.657-0.75-0.986c-0.254-0.334-0.508-0.663-0.766-0.997
		c-0.334-0.428-0.668-0.857-1.006-1.279c5.83-2.38,14.707-7.449,23.349-12.73c3.244,5.913,6.38,11.431,9.455,16.609
		c-8.966,5.392-17.777,10.271-21.928,11.342C424.025,286.718,423.809,286.398,423.588,286.074 M436.126,305.304l-0.033-0.058
		c-0.231-0.359-0.455-0.72-0.69-1.079c-1.089-1.707-2.192-3.436-3.315-5.178c-0.45-0.699-0.905-1.41-1.366-2.114
		c-0.459-0.711-0.92-1.42-1.384-2.129c-0.334-0.518-0.672-1.034-1.01-1.551c-0.398-0.605-0.803-1.217-1.206-1.822
		c-0.409-0.622-0.818-1.237-1.23-1.858c-0.263-0.396-0.526-0.799-0.794-1.195c4.53-1.378,13.126-6.149,21.81-11.374
		c3.595,6.013,7.102,11.573,10.585,16.78c-14.716,8.185-19.43,11.098-20.983,12.298
		C436.374,305.774,436.243,305.529,436.126,305.304 M477.782,318.03c-3.728,2.214-8.145,4.796-12.619,7.141l-0.788,0.417
		c-2.789,1.467-5.676,2.986-8.632,3.686c-0.433,0.099-0.93,0.203-1.394,0.166c-0.061-0.005-0.127-0.015-0.188-0.025
		c-0.023-0.006-0.052-0.011-0.076-0.011c-0.019-0.005-0.033-0.01-0.052-0.01c-0.014-0.006-0.028-0.006-0.042-0.01
		c-0.065-0.016-0.132-0.037-0.201-0.057c-0.099-0.033-0.202-0.069-0.305-0.116c-0.052-0.015-0.109-0.042-0.16-0.067
		c-0.009-0.006-0.014-0.011-0.023-0.016c-0.07-0.032-0.145-0.068-0.221-0.11c-0.033-0.015-0.065-0.031-0.098-0.052
		c-0.066-0.036-0.137-0.073-0.207-0.12c-0.023-0.01-0.051-0.031-0.081-0.047c-0.064-0.042-0.135-0.089-0.201-0.131
		c-0.14-0.093-0.277-0.193-0.418-0.303c-0.104-0.077-0.211-0.161-0.318-0.251c-0.085-0.067-0.175-0.141-0.258-0.219
		c-0.09-0.072-0.174-0.145-0.268-0.234c-0.08-0.069-0.163-0.146-0.248-0.225c-0.099-0.094-0.198-0.187-0.301-0.287
		c-0.089-0.089-0.183-0.177-0.277-0.276c-0.038-0.037-0.07-0.074-0.108-0.11c-0.146-0.152-0.295-0.303-0.446-0.464
		c-0.085-0.094-0.168-0.188-0.258-0.283c-0.206-0.229-0.412-0.464-0.619-0.709c-0.197-0.224-0.39-0.455-0.587-0.695
		c0,0-0.005-0.005-0.005-0.01c-0.159-0.193-0.324-0.392-0.484-0.596c-0.037-0.047-0.075-0.099-0.112-0.145
		c-0.099-0.12-0.197-0.245-0.291-0.371c-0.441-0.569-0.887-1.168-1.333-1.779c-0.164-0.225-0.329-0.455-0.488-0.684
		c-0.089-0.125-0.174-0.245-0.262-0.37c-0.117-0.161-0.231-0.329-0.343-0.496c-0.206-0.292-0.404-0.585-0.606-0.883
		c-0.402-0.589-0.797-1.19-1.192-1.795c-0.402-0.622-0.802-1.247-1.192-1.868c-0.022-0.037-0.042-0.068-0.064-0.104
		c-0.353-0.558-0.695-1.117-1.029-1.665c-0.366-0.6-0.723-1.196-1.065-1.774c-0.348-0.586-0.681-1.154-0.996-1.707
		c-0.065-0.104-0.127-0.209-0.182-0.314c-0.258-0.443-0.503-0.876-0.738-1.293c-0.004-0.006-0.009-0.016-0.014-0.022
		c-0.281-0.512-0.553-0.997-0.807-1.462c0.357-0.287,0.986-0.709,1.846-1.252c0.037-0.026,0.074-0.047,0.112-0.074
		c0.155-0.099,0.32-0.203,0.489-0.306c0.581-0.356,1.238-0.757,1.965-1.191c0.169-0.104,0.343-0.209,0.522-0.313
		c0.357-0.209,0.723-0.429,1.108-0.653c0.193-0.115,0.386-0.229,0.587-0.345c0.202-0.114,0.404-0.235,0.61-0.354
		c0.141-0.083,0.282-0.167,0.428-0.251c0.127-0.073,0.253-0.146,0.385-0.219c0.051-0.031,0.103-0.062,0.159-0.094
		c0.099-0.057,0.201-0.12,0.3-0.171c0.099-0.058,0.193-0.116,0.291-0.168c0.385-0.224,0.775-0.448,1.174-0.679
		c0.365-0.208,0.741-0.422,1.122-0.641c0.63-0.36,1.276-0.725,1.939-1.101c0.413-0.23,0.831-0.465,1.254-0.705
		c0.257-0.146,0.521-0.299,0.784-0.443c0.53-0.299,1.07-0.607,1.615-0.909c0.272-0.151,0.544-0.308,0.822-0.46
		c0.272-0.155,0.549-0.308,0.83-0.464c0.835-0.47,1.689-0.944,2.554-1.426c0.286-0.161,0.577-0.324,0.869-0.484
		c0.385-0.216,0.774-0.434,1.168-0.648c0.484-0.271,0.977-0.543,1.47-0.814c0.591-0.329,1.187-0.658,1.783-0.988
		c0.301-0.167,0.601-0.333,0.9-0.495c1.197-0.663,2.404-1.326,3.611-1.989c0.6-0.335,1.207-0.663,1.807-0.992
		c0.507-0.276,1.014-0.553,1.516-0.83l13.914,25.79C482.692,315.081,480.227,316.578,477.782,318.03 M494.145,305.242
		c-0.019,0.146-0.037,0.297-0.061,0.45c-0.023,0.15-0.051,0.302-0.085,0.448c-0.028,0.135-0.06,0.266-0.093,0.397
		c-0.014,0.041-0.023,0.089-0.038,0.129c0,0.006-0.004,0.011-0.004,0.016c-0.03,0.109-0.061,0.219-0.099,0.329
		c-0.019,0.057-0.038,0.119-0.061,0.183c-0.043,0.131-0.09,0.26-0.141,0.386c-0.009,0.02-0.019,0.048-0.029,0.067
		c-0.005,0.017-0.008,0.027-0.013,0.042c-0.038,0.094-0.076,0.188-0.118,0.277c-0.074,0.173-0.149,0.319-0.23,0.449
		c-0.3,0.501-0.77,0.773-1.309,1.091l-0.268,0.157c-0.685,0.412-1.366,0.83-2.051,1.242l-2.211,1.347
		c-0.348,0.213-0.699,0.428-1.051,0.641l-2.056-3.815l9.862-6.018c0.052,0.313,0.089,0.631,0.103,0.955
		c0.005,0.257,0.005,0.516-0.009,0.778C494.174,304.939,494.165,305.09,494.145,305.242"
        />
        <path
          d="M207.934,134.204c-1.662,0-3.014,1.503-3.014,3.351c0,1.848,1.352,3.351,3.014,3.351c1.662,0,3.014-1.503,3.014-3.351
		C210.948,135.707,209.596,134.204,207.934,134.204 M207.934,139.424c-0.93,0-1.68-0.835-1.68-1.868c0-1.034,0.75-1.868,1.68-1.868
		c0.93,0,1.68,0.834,1.68,1.868C209.615,138.588,208.864,139.424,207.934,139.424"
        />
        <path
          fill="#212121"
          d="M209.615,137.555c0,1.033-0.751,1.868-1.68,1.868c-0.93,0-1.68-0.835-1.68-1.868
		c0-1.034,0.75-1.868,1.68-1.868C208.864,135.687,209.615,136.521,209.615,137.555"
        />
        <path
          d="M164.748,133.682c-1.662,0-3.014,1.504-3.014,3.352c0,1.847,1.352,3.351,3.014,3.351c1.662,0,3.014-1.504,3.014-3.351
		C167.762,135.186,166.41,133.682,164.748,133.682 M164.748,138.902c-0.929,0-1.68-0.835-1.68-1.868c0-1.034,0.751-1.868,1.68-1.868
		c0.93,0,1.68,0.834,1.68,1.868C166.429,138.067,165.678,138.902,164.748,138.902"
        />
        <path
          fill="#212121"
          d="M166.429,137.033c0,1.034-0.751,1.868-1.68,1.868c-0.93,0-1.68-0.834-1.68-1.868
		c0-1.034,0.75-1.868,1.68-1.868C165.678,135.165,166.429,135.999,166.429,137.033"
        />
        <path
          d="M167.095,278.788c-1.662,0-3.014,1.504-3.014,3.352c0,1.847,1.352,3.351,3.014,3.351c1.662,0,3.014-1.504,3.014-3.351
		C170.109,280.292,168.757,278.788,167.095,278.788 M167.095,284.008c-0.93,0-1.68-0.835-1.68-1.868c0-1.034,0.75-1.87,1.68-1.87
		c0.929,0,1.68,0.835,1.68,1.87C168.776,283.173,168.024,284.008,167.095,284.008"
        />
        <path
          fill="#212121"
          d="M168.776,282.139c0,1.033-0.751,1.868-1.68,1.868c-0.93,0-1.68-0.835-1.68-1.868
		c0-1.033,0.75-1.868,1.68-1.868C168.024,280.271,168.776,281.106,168.776,282.139"
        />
        <path
          d="M208.404,290.271c-1.662,0-3.014,1.504-3.014,3.352c0,1.847,1.352,3.351,3.014,3.351c1.662,0,3.014-1.504,3.014-3.351
		C211.417,291.775,210.066,290.271,208.404,290.271 M208.404,295.491c-0.93,0-1.68-0.834-1.68-1.868c0-1.034,0.75-1.87,1.68-1.87
		c0.929,0,1.68,0.835,1.68,1.87C210.084,294.657,209.333,295.491,208.404,295.491"
        />
        <path
          fill="#212121"
          d="M210.084,293.622c0,1.034-0.751,1.868-1.68,1.868c-0.93,0-1.68-0.834-1.68-1.868
		c0-1.033,0.75-1.868,1.68-1.868C209.333,291.754,210.084,292.589,210.084,293.622"
        />
        <path
          d="M290.551,291.315c-1.662,0-3.014,1.504-3.014,3.352c0,1.847,1.352,3.351,3.014,3.351s3.014-1.504,3.014-3.351
		C293.565,292.819,292.213,291.315,290.551,291.315 M290.551,296.535c-0.929,0-1.68-0.835-1.68-1.868c0-1.034,0.751-1.87,1.68-1.87
		s1.68,0.835,1.68,1.87C292.232,295.7,291.48,296.535,290.551,296.535"
        />
        <path
          fill="#212121"
          d="M292.232,294.666c0,1.033-0.751,1.868-1.68,1.868c-0.93,0-1.681-0.835-1.681-1.868
		c0-1.033,0.751-1.868,1.681-1.868C291.481,292.798,292.232,293.634,292.232,294.666"
        />
        <path
          d="M230.701,371.959c-2.177,0-3.953,1.973-3.953,4.395c0,2.421,1.775,4.395,3.953,4.395c2.178,0,3.953-1.974,3.953-4.395
		C234.653,373.932,232.879,371.959,230.701,371.959 M230.701,379.266c-1.446,0-2.619-1.304-2.619-2.912
		c0-1.607,1.174-2.914,2.619-2.914c1.447,0,2.619,1.307,2.619,2.914C233.32,377.962,232.147,379.266,230.701,379.266"
        />
        <path
          fill="#212121"
          d="M233.32,376.354c0,1.607-1.173,2.912-2.619,2.912c-1.446,0-2.619-1.304-2.619-2.912
		c0-1.607,1.174-2.913,2.619-2.913C232.147,373.441,233.32,374.747,233.32,376.354"
        />
        <path
          d="M232.109,306.192c-2.178,0-3.953,1.973-3.953,4.394s1.774,4.395,3.953,4.395c2.177,0,3.953-1.974,3.953-4.395
		S234.287,306.192,232.109,306.192 M232.109,313.499c-1.447,0-2.619-1.304-2.619-2.913c0-1.607,1.173-2.913,2.619-2.913
		c1.445,0,2.619,1.305,2.619,2.913C234.729,312.195,233.555,313.499,232.109,313.499"
        />
        <path
          fill="#212121"
          d="M234.729,310.586c0,1.608-1.174,2.913-2.619,2.913c-1.446,0-2.619-1.304-2.619-2.913
		c0-1.607,1.174-2.912,2.619-2.912C233.555,307.674,234.729,308.979,234.729,310.586"
        />
        <path
          d="M233.518,237.815c-2.178,0-3.953,1.973-3.953,4.395c0,2.421,1.774,4.394,3.953,4.394c2.178,0,3.953-1.973,3.953-4.394
		C237.47,239.788,235.696,237.815,233.518,237.815 M233.518,245.121c-1.447,0-2.619-1.304-2.619-2.912
		c0-1.608,1.173-2.914,2.619-2.914c1.445,0,2.619,1.305,2.619,2.914C236.137,243.817,234.963,245.121,233.518,245.121"
        />
        <path
          fill="#212121"
          d="M236.137,242.209c0,1.607-1.174,2.912-2.619,2.912c-1.445,0-2.619-1.304-2.619-2.912
		c0-1.608,1.174-2.913,2.619-2.913C234.963,239.297,236.137,240.601,236.137,242.209"
        />
        <path
          d="M236.803,165.261c-2.178,0-3.953,1.973-3.953,4.395c0,2.421,1.774,4.395,3.953,4.395c2.178,0,3.953-1.974,3.953-4.395
		C240.756,167.234,238.982,165.261,236.803,165.261 M236.803,172.569c-1.447,0-2.619-1.305-2.619-2.913
		c0-1.607,1.173-2.913,2.619-2.913c1.447,0,2.619,1.305,2.619,2.913C239.423,171.263,238.25,172.569,236.803,172.569"
        />
        <path
          fill="#212121"
          d="M239.423,169.656c0,1.607-1.173,2.913-2.619,2.913c-1.446,0-2.619-1.305-2.619-2.913
		c0-1.608,1.174-2.913,2.619-2.913C238.25,166.743,239.423,168.048,239.423,169.656"
        />
        <path
          d="M243.375,94.274c-2.178,0-3.953,1.973-3.953,4.394c0,2.422,1.774,4.395,3.953,4.395c2.178,0,3.953-1.973,3.953-4.395
		C247.328,96.247,245.554,94.274,243.375,94.274 M243.375,101.581c-1.445,0-2.619-1.304-2.619-2.913
		c0-1.607,1.174-2.913,2.619-2.913c1.447,0,2.619,1.305,2.619,2.913C245.995,100.277,244.822,101.581,243.375,101.581"
        />
        <path
          fill="#212121"
          d="M245.994,98.669c0,1.608-1.173,2.913-2.619,2.913c-1.445,0-2.619-1.304-2.619-2.913
		c0-1.607,1.174-2.913,2.619-2.913C244.822,95.756,245.994,97.061,245.994,98.669"
        />
        <path
          d="M244.314,51.995c-2.178,0-3.953,1.973-3.953,4.395c0,2.421,1.774,4.395,3.953,4.395c2.178,0,3.953-1.974,3.953-4.395
		C248.267,53.967,246.493,51.995,244.314,51.995 M244.314,59.302c-1.447,0-2.619-1.305-2.619-2.913c0-1.607,1.173-2.913,2.619-2.913
		c1.445,0,2.619,1.305,2.619,2.913C246.934,57.997,245.76,59.302,244.314,59.302"
        />
        <path
          fill="#212121"
          d="M246.934,56.39c0,1.607-1.174,2.913-2.619,2.913c-1.445,0-2.619-1.305-2.619-2.913
		c0-1.608,1.174-2.913,2.619-2.913C245.76,53.477,246.934,54.781,246.934,56.39"
        />
        <path
          d="M333.268,280.354c-1.662,0-3.014,1.504-3.014,3.351c0,1.848,1.352,3.352,3.014,3.352s3.014-1.504,3.014-3.352
		C336.281,281.858,334.93,280.354,333.268,280.354 M333.268,285.573c-0.929,0-1.68-0.834-1.68-1.868c0-1.034,0.751-1.868,1.68-1.868
		c0.929,0,1.68,0.834,1.68,1.868C334.948,284.739,334.197,285.573,333.268,285.573"
        />
        <path
          fill="#212121"
          d="M334.949,283.705c0,1.033-0.751,1.868-1.68,1.868c-0.93,0-1.681-0.835-1.681-1.868
		c0-1.034,0.751-1.868,1.681-1.868C334.197,281.837,334.949,282.671,334.949,283.705"
        />
        <path
          fill="#010101"
          d="M229.058,77.247c-1.173,0-2.13,1.066-2.13,2.37c0,1.305,0.958,2.37,2.13,2.37
		c1.174,0,2.132-1.065,2.132-2.37C231.189,78.313,230.232,77.247,229.058,77.247 M229.058,81.423c-0.896,0-1.624-0.808-1.624-1.806
		c0-0.997,0.728-1.806,1.624-1.806c0.896,0,1.624,0.809,1.624,1.806C230.682,80.615,229.954,81.423,229.058,81.423"
        />
        <path
          fill="#010101"
          d="M229.058,78.432c-0.587,0-1.066,0.532-1.066,1.185c0,0.652,0.479,1.185,1.066,1.185
		c0.587,0,1.066-0.534,1.066-1.185C230.124,78.965,229.645,78.432,229.058,78.432 M229.058,80.52c-0.45,0-0.812-0.402-0.812-0.902
		c0-0.502,0.361-0.904,0.812-0.904c0.45,0,0.812,0.402,0.812,0.904C229.87,80.118,229.508,80.52,229.058,80.52"
        />
        <path
          fill="#010101"
          d="M229.87,79.617c0,0.501-0.361,0.902-0.812,0.902c-0.451,0-0.813-0.402-0.813-0.902
		c0-0.501,0.361-0.902,0.813-0.902C229.509,78.715,229.87,79.116,229.87,79.617"
        />
        <path
          fill="#010101"
          d="M269.897,78.291c-1.173,0-2.132,1.065-2.132,2.37c0,1.305,0.959,2.37,2.132,2.37s2.13-1.065,2.13-2.37
		C272.028,79.356,271.07,78.291,269.897,78.291 M269.897,82.467c-0.897,0-1.624-0.809-1.624-1.806c0-0.997,0.727-1.806,1.624-1.806
		c0.896,0,1.624,0.809,1.624,1.806C271.521,81.658,270.794,82.467,269.897,82.467"
        />
        <path
          fill="#010101"
          d="M269.897,79.477c-0.587,0-1.066,0.531-1.066,1.184c0,0.653,0.479,1.185,1.066,1.185
		c0.586,0,1.066-0.532,1.066-1.185C270.963,80.008,270.483,79.477,269.897,79.477 M269.897,81.564c-0.45,0-0.813-0.402-0.813-0.904
		c0-0.501,0.362-0.902,0.813-0.902c0.45,0,0.812,0.402,0.812,0.902C270.709,81.162,270.347,81.564,269.897,81.564"
        />
        <path
          fill="#010101"
          d="M270.709,80.661c0,0.501-0.361,0.904-0.812,0.904s-0.813-0.403-0.813-0.904
		c0-0.501,0.362-0.902,0.813-0.902S270.709,80.16,270.709,80.661"
        />
      </g>
    </svg>
  );
}
